//Event.js
import * as types from './action-types';
import * as endpoints from '../helpers/endpoints';
import searchFormat from '../helpers/search';
import apiRequest from '../helpers/apiRequest';
import { actions } from 'react-redux-form';
import moment from 'moment';
import { last, sortBy } from 'lodash';
import getStatus from '../helpers/status-substatus';

import {
    unAuthUser,
    assignAssigneeAfterAction,
    assigneeUserName,
    assignedLocationReset
} from './index';

export const createEventThunk = data => (dispatch, getState) => {
    dispatch(eventActionOverlayLoading('Saving Event'));
    apiRequest(
        `${endpoints.CREATE_EVENT_PATH}`,
        getState().auth.jwtToken,
        'POST',
        JSON.stringify({ data })
    ).then(payload => {
        if (payload.errors) {
            if (Array.isArray(payload.errors[0].detail)) {
                dispatch(
                    setEventErrorMessage(payload.errors[0].detail[0].detail)
                );
            } else {
                dispatch(setEventErrorMessage(payload.errors[0].detail));
            }
        } else {
            dispatch(clearAllErrors());
            dispatch(fetchCreateEvent(payload));
            dispatch(setEventIdInForm(payload.data.id));
            dispatch(setEventId(payload.data.id));
            dispatch(setUserIsCreator(true));
            dispatch(calcPRSaveSubmit());

            const storedVendors = getState().events.storedVendors;
            if (storedVendors.length > 0) {
                const eventId = payload.data.id;
                for (let i = 0; i < storedVendors.length; i += 1) {
                    const vendor = storedVendors[i];
                    const vendorObj = {
                        vendor: vendor.id,
                        event: eventId
                    };
                    dispatch(assignVendorItem(vendorObj));
                }
                dispatch(clearVendorItems());
            } else {
                dispatch(
                    setEventSuccessMessage(
                        `Event saved at ${moment().format(
                            'YYYY-MM-DD HH:MM:SS'
                        )}.`
                    )
                );
            }

            const onsiteDates = getState().ui.onSiteAddDates;
            if (onsiteDates.length > 0) {
                for (let i = 0; i < onsiteDates.length; i += 1) {
                    const item = onsiteDates[i];
                    let dateObj = {
                        date: item.date,
                        eventId: payload.data.id
                    };
                    if (item.id) {
                        dateObj.id = item.id;
                        dispatch(updateOnsiteDateThunk(dateObj));
                    } else {
                        dispatch(createOnsiteDateThunk(dateObj));
                    }
                }
            }

            if (getState().events.prInfo) {
                const prObj = JSON.parse(
                    JSON.stringify(getState().events.prInfo)
                );
                prObj.eventId = payload.data.id;
                dispatch(createPurchaseRequestThunk(prObj));
                dispatch(storePurchaseRequest(null));
            }

            //If there is 1 image or more run this function
            dispatch(createEventAttachedDocumentsThunk(payload.data.id));
        }
        dispatch(eventActionOverlaySuccess());
    });
};

export const createAndSubmitEventThunk = data => (dispatch, getState) => {
    dispatch(eventActionOverlayLoading('Create and Submitting Event'));
    apiRequest(
        `${endpoints.CREATE_EVENT_PATH}`,
        getState().auth.jwtToken,
        'POST',
        JSON.stringify({ data })
    ).then(payload => {
        if (payload.errors) {
            if (Array.isArray(payload.errors[0].detail)) {
                dispatch(
                    setEventErrorMessage(payload.errors[0].detail[0].detail)
                );
            } else {
                dispatch(setEventErrorMessage(payload.errors[0].detail));
            }
            dispatch(eventActionOverlaySuccess());
        } else {
            dispatch(
                setEventSuccessMessage(
                    `Event saved at ${moment().format('YYYY-MM-DD HH:MM:SS')}`
                )
            );
            dispatch(clearAllErrors());
            dispatch(submitEventThunk(payload.data));
            dispatch(setEventName(payload.data.qualifiedName));
            dispatch(fetchCreateEvent(payload));
            dispatch(setEventIdInForm(payload.data.id));
            dispatch(setEventId(payload.data.id));
            dispatch(setUserIsCreator(true));

            //Only is set when the assignee has a value
            if (getState().event.assignee) {
                dispatch(
                    assignAssigneeAfterAction(
                        payload.data.id,
                        getState().event.assignee
                    )
                );
            }

            const storedVendors = getState().events.storedVendors;
            if (storedVendors.length > 0) {
                const eventId = payload.data.id;
                for (let i = 0; i < storedVendors.length; i += 1) {
                    const vendor = storedVendors[i];
                    const vendorObj = {
                        vendor: vendor.id,
                        event: eventId
                    };
                    dispatch(assignVendorItem(vendorObj));
                }
                dispatch(clearVendorItems());
            }

            if (getState().events.prInfo) {
                const prObj = JSON.parse(
                    JSON.stringify(getState().events.prInfo)
                );
                prObj.eventId = payload.data.id;
                dispatch(createPurchaseRequestThunk(prObj));
                dispatch(storePurchaseRequest(null));
            }

            const onsiteDates = getState().ui.onSiteAddDates;
            if (onsiteDates.length > 0) {
                for (let i = 0; i < onsiteDates.length; i += 1) {
                    const item = onsiteDates[i];
                    let dateObj = {
                        date: item.date,
                        eventId: payload.data.id
                    };
                    if (item.id) {
                        dateObj.id = item.id;
                        dispatch(updateOnsiteDateThunk(dateObj));
                    } else {
                        dispatch(createOnsiteDateThunk(dateObj));
                    }
                }
            }

            dispatch(attachedDocumentsThunk(data));
            dispatch(calcPRSaveSubmit());
        }
    });
};

export const setEventIdInForm = id => dispatch => {
    dispatch(actions.change('event.id', id));
};

export const submitEventThunk = data => (dispatch, getState) => {
    let postBody = JSON.stringify({ data: { id: data.id } });
    if (data.approverId) {
        postBody = JSON.stringify({
            data: { id: data.id, next: data.approverId }
        });
    }
    apiRequest(
        `${endpoints.SUBMIT_EVENT_PATH}`,
        getState().auth.jwtToken,
        'POST',
        postBody
    ).then(payload => {
        if (payload.errors) {
            if (Array.isArray(payload.errors[0].detail)) {
                dispatch(
                    setEventErrorMessage(payload.errors[0].detail[0].detail)
                );
            } else {
                dispatch(setEventErrorMessage(payload.errors[0].detail));
            }
            dispatch(eventActionOverlaySuccess());
        } else {
            dispatch(clearAllErrors());
            dispatch(
                setEventSuccessMessage(
                    `Event submitted at ${moment().format(
                        'YYYY-MM-DD HH:MM:SS'
                    )}.`
                )
            );
            dispatch(fetchEventSuccess('Unapproved'));
            dispatch(fetchEventTaskThunk(data.id));

            if (payload.data.status && payload.data.status === 'Approved') {
                dispatch(fetchEventSuccess('Approved'));
            }

            dispatch(calcEventSaveSubmit());
            dispatch(calcEventApproveReject());
            dispatch(calcPRSaveSubmit());
            if (payload.data.eacCode) {
                dispatch(actions.change('event.eacCode', payload.data.eacCode));
            }
            dispatch(eventActionOverlaySuccess());
        }
    });
};

export const createTaskSuccess = task => (dispatch, getState) => {
    return {
        type: types.ADD_EVENT_TASK,
        task
    };
};

export const resetEvent = () => (dispatch, getState) => {
    dispatch(resetEventStatus());
    dispatch(setEventId(null));
    dispatch(setEventName(null));
    dispatch(setEventSuccessMessage(null));
    dispatch(setEventErrorMessage(null));
    dispatch(setEventFiles([]));
    dispatch(clearVendorItems());
    dispatch(setPRComplete(false));
    dispatch(storePurchaseRequest(null));
    dispatch(setOnsiteDates([]));
    dispatch(setAARecommended(true));
    dispatch(setRejectComments(null));
    dispatch(setSelectedCategories([]));
    dispatch(setAARequestMessage(null));
    dispatch(fetchEventTaskSuccess([]));
    dispatch(fetchAATaskSuccess([]));
    dispatch(setEventEndDate(null));
    dispatch(setShowEventRecommend(false));
    dispatch(setEventRecommended(true));
    dispatch(setEventUserAction(null));
    dispatch(setApproverState(false));
    dispatch(setGroupStatus(null, null));
    dispatch(setEventAfterActionsMod(false));

    const userInfo = getState().data.userInfo;
    let hasActions = false;
    if (userInfo.permissions && userInfo.permissions.approvers) {
        hasActions = true;
    }
    dispatch(setEventActions(hasActions));
    dispatch(setUserIsCreator(false));

    const validObj = {
        formOneValid: true,
        formTwoValid: true
    };
    dispatch(setInvalidTabs(validObj));
    dispatch(fetchEventApprovers(0));

    const initialEventState = {
        name: '',
        approverId: null,
        contract: null,
        endTime: '',
        purpose: null,
        estAttendance: null,
        isFromEac: null,
        startTime: '',
        state: null,
        cost: null,
        city: '',
        uploadedFiles: [],
        vendorForm: {},
        vendorsInformation: [],
        behavior: false,
        awareness: false,
        sDate: null,
        eDate: null,
        eventFile: [],
        category: [],
        formSaved: true,
        fiscalYear: null,
        showParentIdField: null,
        estEngagements: null,
        estMediaPosts: null,
        estMediaImpressions: null,
        estSocialMediaPosts: null,
        estSocialMediaImpressions: null,
        estQualifiedLeads: null,
        estInfluencerContacts: null,
        estFollowUps: null,
        estInteraction: null,
        estInfluencerInteraction: null,
        deliverable: null,
        addlDeliverables: null,
        estOnsiteActivations: null,
        dateContractedSigned: null,
        aabehavior: false,
        aaawareness: false,
        ossRssType: null
    };

    const initialPurchaseRequestState = {
        name: '',
        totalCost: '',
        dateCreated: '',
        dateRequired: '',
        contactName: '',
        contactPhone: '',
        contactEmail: '',
        itemizedCost: '',
        PurchaseRequestItem: [],
        newItem: {
            purchaseRequestId: null,
            unitOfIssue: 'EACH'
        },
        id: null,
        Documents: [],
        Photos: []
    };

    if (userInfo.District) {
        initialEventState.fundingRegionCode = userInfo.District.Region.code;
        initialEventState.fundingDistrictCode = userInfo.District.code;
        dispatch(updateFundedDistrict(userInfo.District.Region.code, false));
        dispatch(updateFundedRS(userInfo.District.code, false));

        if (userInfo.RS) {
            dispatch(updateFundedRSS(userInfo.RS.code, false));
            initialEventState.fundingRecruitingStationCode = userInfo.RS.code;

            if (userInfo.RSS) {
                initialEventState.fundingRssOrOss = `${userInfo.RSS.code}-RSS`;
                initialEventState.ossRssType = 'RSS';
            } else if (userInfo.OSS) {
                initialEventState.fundingRssOrOss = `${
                    userInfo.OSS.ossNumber
                }-OSS`;
                initialEventState.ossRssType = 'OSS';
            }
        }
    } else if (userInfo.regionCode) {
        initialEventState.fundingRegionCode = userInfo.regionCode;
        dispatch(updateFundedDistrict(userInfo.regionCode, false));
    }
    dispatch(calcEventSaveSubmit());
    dispatch(setEventApproveReject(false));
    dispatch(setPRSaveSubmit(false));
    dispatch(setPRAccessible(false));
    dispatch(setPRStatus(null));
    dispatch(setAAStatus(null));
    //Assigned location section
    dispatch(actions.change('event.assignAfterAction', false));
    dispatch(assignedLocationReset());

    dispatch(actions.reset('event'));
    dispatch(actions.load('event', initialEventState));
    dispatch(actions.load('PurchaseRequest', initialPurchaseRequestState));
};

export const setFormPristine = () => dispatch => {
    dispatch(actions.setPristine('event'));
};

export const resetEventStatus = () => {
    return {
        type: types.SET_EVENT_STATUS,
        status: 'Incomplete'
    };
};

export const setInvalidTabs = validObj => {
    return {
        type: types.SET_INVALID_TABS,
        validObj
    };
};

export const fetchCreateEvent = event => {
    return {
        type: types.CREATE_EVENT,
        event
    };
};

export const fetchEventReport = eventReport => {
    return {
        type: types.CREATE_EVENT_REPORT,
        eventReport
    };
};

export const fetchEventLoading = () => {
    return {
        type: types.EVENT_LOADING
    };
};

export const fetchEventLoadingSuccess = () => {
    return {
        type: types.EVENT_LOADING_SUCCESS
    };
};

export const fetchEventThunk = (id, history) => (dispatch, getState) => {
    dispatch(fetchEventLoading());
    //Reset user action of submit, reject, request and etc ...
    dispatch(setEventUserAction(null));
    apiRequest(
        `${
            endpoints.EVENT_DETAIL_PATH
        }/${id}?include[]=PurchaseRequest&include[]=Category&include[]=Vendor&include[]=EventReport&include[]=Documents&include[]=Photos&include[]=PromotionalItem&include[]=OnsiteDate&include[]=EventComment`,
        getState().auth.jwtToken
    ).then(payload => {
        if (payload.errors) {
            if (Array.isArray(payload.errors[0].detail)) {
                dispatch(
                    setEventErrorMessage(payload.errors[0].detail[0].detail)
                );
            } else {
                dispatch(setEventErrorMessage(payload.errors[0].detail));
            }
        } else {
            // Reset any messages that may be displayed.
            dispatch(setEventSuccessMessage(null));
            dispatch(clearAllErrors());
            // Format data for use in the form.
            const formData = payload.data[0];
            formData.sDate = moment(formData.startDate);
            formData.startTime = moment(formData.startDate).format('HH:mm');
            if (formData.endDate) {
                formData.eDate = moment(formData.endDate);
                formData.endTime = moment(formData.endDate).format('HH:mm');
                dispatch(setEventEndDate(formData.endDate));
            }
            if (formData.dateContractedSigned) {
                formData.dateContractedSigned = moment(
                    formData.dateContractedSigned
                );
            } else {
                //Fill in dummy data for created events that had nan
                formData.dateContractedSigned = '';
            }
            formData.isFromEac = formData.isFromEac ? '1' : '0';
            formData.contract = formData.contract ? '1' : '0';
            formData.isFromPr = formData.isFromPr ? '1' : '0';
            if (!formData.category && !formData.Category) {
                formData.category = [];
            } else if (formData.Category) {
                if (formData.Category.length > 0) {
                    formData.category = formData.Category.map(item => {
                        return {
                            value: item.id,
                            label: item.name
                        };
                    });
                } else {
                    formData.category = [];
                }
            }
            dispatch(setSelectedCategories(formData.category));
            delete formData.Category;
            if (formData.parentId) {
                formData.showParentIdField = '1';
                dispatch(fetchParentIDEventName(formData.parentId));
            } else {
                formData.showParentIdField = '0';
            }
            if (formData.Vendors) {
                formData.vendorsInformation = formData.Vendors;
            } else {
                formData.vendorsInformation = [];
            }

            if (formData.Photos.length > 0 || formData.Documents.length > 0) {
                const eventFiles = formData.Photos.concat(formData.Documents);
                dispatch(setEventFiles(eventFiles));
            } else {
                dispatch(setEventFiles([]));
            }

            if (!formData.behavior) {
                formData.behavior = false;
            } else {
                formData.behavior = formData.behavior ? '1' : false;
            }
            if (!formData.awareness) {
                formData.awareness = false;
            } else {
                if (formData.awareness === true) {
                    formData.awareness = '1';
                }
            }

            // For values that is 0 to make it into a string "0"
            formData.estMediaPosts =
                formData.estMediaPosts === 0
                    ? formData.estMediaPosts.toString()
                    : formData.estMediaPosts;
            formData.estAttendance =
                formData.estAttendance === 0
                    ? formData.estAttendance.toString()
                    : formData.estAttendance;
            formData.estEngagements =
                formData.estEngagements === 0
                    ? formData.estEngagements.toString()
                    : formData.estEngagements;
            formData.estMediaImpressions =
                formData.estMediaImpressions === 0
                    ? formData.estMediaImpressions.toString()
                    : formData.estMediaImpressions;
            formData.estSocialMediaPosts =
                formData.estSocialMediaPosts === 0
                    ? formData.estSocialMediaPosts.toString()
                    : formData.estSocialMediaPosts;
            formData.estSocialMediaImpressions =
                formData.estSocialMediaImpressions === 0
                    ? formData.estSocialMediaImpressions.toString()
                    : formData.estSocialMediaImpressions;
            formData.estQualifiedLeads =
                formData.estQualifiedLeads === 0
                    ? formData.estQualifiedLeads.toString()
                    : formData.estQualifiedLeads;
            formData.estInfluencerContacts =
                formData.estInfluencerContacts === 0
                    ? formData.estInfluencerContacts.toString()
                    : formData.estInfluencerContacts;
            formData.estFollowUps =
                formData.estFollowUps === 0
                    ? formData.estFollowUps.toString()
                    : formData.estFollowUps;
            formData.estInteraction =
                formData.estInteraction === 0
                    ? formData.estInteraction.toString()
                    : formData.estInteraction;
            formData.estInfluencerInteraction =
                formData.estInfluencerInteraction === 0
                    ? formData.estInfluencerInteraction.toString()
                    : formData.estInfluencerInteraction;
            formData.estOnsiteActivations =
                formData.estOnsiteActivations === 0
                    ? formData.estOnsiteActivations.toString()
                    : formData.estOnsiteActivations;

            if (!formData.vendorsInformation) {
                formData.vendorsInformation = [];
            }

            if (formData.OnsiteDate.length > 0) {
                dispatch(setOnsiteDates(formData.OnsiteDate));
            }

            if (formData.estOnsiteActivations) {
                dispatch(setOnsiteActivations(formData.estOnsiteActivations));
            }

            if (formData.EventReport) {
                //Fetch the assignee username
                if (formData.EventReport.userId !== formData.createdById) {
                    dispatch(assigneeUserName(formData.EventReport.userId));
                }
                formData.reportId = formData.EventReport.id;
                formData.description = formData.EventReport.description;
                formData.objective = formData.EventReport.objective;
                formData.aaawareness = formData.EventReport.awareness;
                formData.attendance =
                    formData.EventReport.attendance === 0
                        ? formData.EventReport.attendance.toString()
                        : formData.EventReport.attendance;
                formData.engagements =
                    formData.EventReport.engagements === 0
                        ? formData.EventReport.engagements.toString()
                        : formData.EventReport.engagements;
                formData.mediaPosts =
                    formData.EventReport.mediaPosts === 0
                        ? formData.EventReport.mediaPosts.toString()
                        : formData.EventReport.mediaPosts;
                formData.aaApproverId = formData.EventReport.approverId;
                formData.estimatedAttendance =
                    formData.EventReport.estimatedAttendance === 0
                        ? formData.EventReport.estimatedAttendance.toString()
                        : formData.EventReport.estimatedAttendance;
                formData.mediaImpressions =
                    formData.EventReport.mediaImpressions === 0
                        ? formData.EventReport.mediaImpressions.toString()
                        : formData.EventReport.mediaImpressions;
                formData.socialMediaPosts =
                    formData.EventReport.socialMediaPosts === 0
                        ? formData.EventReport.socialMediaPosts.toString()
                        : formData.EventReport.socialMediaPosts;
                formData.socialMediaImpressions =
                    formData.EventReport.socialMediaImpressions === 0
                        ? formData.EventReport.socialMediaImpressions.toString()
                        : formData.EventReport.socialMediaImpressions;
                formData.aabehavior = formData.EventReport.behavior;
                formData.influencerContacts =
                    formData.EventReport.influencerContacts === 0
                        ? formData.EventReport.influencerContacts.toString()
                        : formData.EventReport.influencerContacts;
                formData.followUps =
                    formData.EventReport.followUps === 0
                        ? formData.EventReport.influencerContacts.toString()
                        : formData.EventReport.influencerContacts;
                formData.interaction =
                    formData.EventReport.interaction === 0
                        ? formData.EventReport.interaction.toString()
                        : formData.EventReport.interaction;
                formData.influencerInteraction =
                    formData.EventReport.influencerInteraction === 0
                        ? formData.EventReport.influencerInteraction.toString()
                        : formData.EventReport.influencerInteraction;
                formData.problems = formData.EventReport.problems;
                formData.aadeliverable = formData.EventReport.deliverable;

                if (formData.EventReport.attended !== null) {
                    formData.attended = formData.EventReport.attended
                        ? '1'
                        : '0';
                } else {
                    formData.attended = '';
                }

                if (formData.EventReport.electricity !== null) {
                    formData.electricity = formData.EventReport.electricity
                        ? '1'
                        : '0';
                } else {
                    formData.electricity = '';
                }

                if (formData.EventReport.accommodating !== null) {
                    formData.accommodating = formData.EventReport.accommodating
                        ? '1'
                        : '0';
                } else {
                    formData.accommodating = '';
                }

                if (formData.EventReport.recommend !== null) {
                    formData.aaRecommend = formData.EventReport.recommend
                        ? '1'
                        : '0';
                } else {
                    formData.aaRecommend = '';
                }

                if (formData.EventReport.emvAttend !== null) {
                    formData.emvAttend = formData.EventReport.emvAttend
                        ? '1'
                        : '0';
                } else {
                    formData.emvAttend = '';
                }

                formData.leadCards =
                    formData.EventReport.leadCards === 0
                        ? formData.EventReport.leadCards.toString()
                        : formData.EventReport.leadCards;
                formData.interviewsScheduled =
                    formData.EventReport.interviewsScheduled;
                formData.recruiter = formData.EventReport.recruiter;
                formData.marinesAttendance =
                    formData.EventReport.marinesAttendance === 0
                        ? formData.EventReport.marinesAttendance.toString()
                        : formData.EventReport.marinesAttendance;

                if (formData.aaRecommend === '0') {
                    dispatch(setAARecommended(false));
                }
                formData.aaRecommendReason =
                    formData.EventReport.recommendReason;
                formData.targetMarketRating =
                    formData.EventReport.targetMarketRating;
                formData.targetMarketComments =
                    formData.EventReport.targetMarketComments;
                formData.estimatedTargetAttendance =
                    formData.EventReport.estimatedTargetAttendance === 0
                        ? formData.EventReport.estimatedTargetAttendance.toString()
                        : formData.EventReport.estimatedTargetAttendance;
                formData.comingOfAgeRating =
                    formData.EventReport.comingOfAgeRating;
                formData.comingOfAgeComments =
                    formData.EventReport.comingOfAgeComments;
                formData.influentialRating =
                    formData.EventReport.influentialRating;
                formData.influentialComments =
                    formData.EventReport.influentialComments;
                formData.communityRelationsRating =
                    formData.EventReport.communityRelationsRating;
                formData.communityRelationsComments =
                    formData.EventReport.communityRelationsComments;
                formData.leadGenerationRating =
                    formData.EventReport.leadGenerationRating;
                formData.leadGenerationComments =
                    formData.EventReport.leadGenerationComments;
                formData.keyParticipants = formData.EventReport.keyParticipants;
                formData.problems = formData.EventReport.problems;
                formData.concerns = formData.EventReport.concerns;
                formData.comments = formData.EventReport.comments;
                formData.tShirt = formData.EventReport.tShirt
                    ? formData.EventReport.tshirt
                    : 0;
                formData.lanyards = formData.EventReport.lanyards
                    ? formData.EventReport.lanyards
                    : 0;
                formData.waterBottles = formData.EventReport.waterBottles
                    ? formData.EventReport.waterBottles
                    : 0;
                formData.hats = formData.EventReport.hats
                    ? formData.EventReport.hats
                    : 0;
                formData.promoTotal = formData.EventReport.promoTotal
                    ? formData.EventReport.promoTotal
                    : 0;
                dispatch(getEventReportMediaThunk(formData.EventReport.id));
                dispatch(setAAStatus(formData.EventReport.subStatus));
            }

            dispatch(fetchEventSuccess(formData.status));

            // Region
            if (formData.fundingRegionCode) {
                dispatch(
                    updateFundedDistrict(formData.fundingRegionCode, false)
                );
            } else {
                formData.fundingRegionCode = 'national';
            }
            // District
            if (formData.fundingDistrictCode) {
                dispatch(updateFundedRS(formData.fundingDistrictCode, false));
            }

            //RS
            if (formData.fundingOssCode) {
                formData.ossRssType = 'OSS';
                dispatch(
                    updateFundedRSS(
                        formData.fundingRecruitingStationCode,
                        false
                    )
                );
            } else if (formData.fundingRecruitingSubStationCode) {
                formData.ossRssType = 'RSS';
                dispatch(
                    updateFundedRSS(
                        formData.fundingRecruitingStationCode,
                        false
                    )
                );
            }
            //Set the RSS and OSS on fetch
            if (
                formData.fundingRecruitingSubStationCode &&
                formData.ossRssType === 'RSS'
            ) {
                formData.fundingRecruitingSubStationCode =
                    formData.fundingRecruitingSubStationCode;
                formData.fundingRssOrOss = `${
                    formData.fundingRecruitingSubStationCode
                }-RSS`;
            } else if (
                formData.fundingOssCode &&
                formData.ossRssType === 'OSS'
            ) {
                formData.fundingOssCode = formData.ossCode;
                formData.fundingRssOrOss = `${formData.ossCode}-OSS`;
            }

            if (
                formData.PurchaseRequest &&
                formData.PurchaseRequest.length > 0
            ) {
                dispatch(setPRComplete(true));
                if (formData.PurchaseRequest.status) {
                    dispatch(setPRStatus(formData.PurchaseRequest.status));
                } else {
                    dispatch(setPRStatus(null));
                }
            } else {
                dispatch(setPRComplete(false));
            }

            /*
             * Set some data about the user to be used when determining viable
             * user actions and approverIds
             */
            const userInfo = getState().data.userInfo;
            /*
             * Determine if this user created the event
             */
            let userIsCreator = false;

            if (userInfo.TrustingUser) {
                if (
                    userInfo.TrustingUser.id === formData.createdById ||
                    userInfo.TrustingUser.username ===
                        formData.createdByUsername
                )
                    userIsCreator = true;
            }

            if (
                userInfo.id === formData.createdById
                //|| userInfo.username === formData.createdByUsername
            ) {
                userIsCreator = true;
            }

            dispatch(setUserIsCreator(userIsCreator));

            // Check if user is a MCRC who has uploade a file
            if (userInfo.Billet.location === 'MCRC') {
                let hasUploadedFile = false;
                if (formData.Photos.length > 0) {
                    const eventItems = formData.Photos.filter(
                        item => item.resourceType === 'Event'
                    );
                    for (let i = 0; i < eventItems.length; i += 1) {
                        const doc = eventItems[i];
                        if (doc.createdById === userInfo.id) {
                            hasUploadedFile = true;
                            break;
                        }
                    }
                } else if (!hasUploadedFile && formData.Documents.length > 0) {
                    const eventItems = formData.Documents.filter(
                        item => item.resourceType === 'Event'
                    );
                    for (let i = 0; i < eventItems.length; i += 1) {
                        const doc = eventItems[i];
                        if (doc.createdById === userInfo.id) {
                            hasUploadedFile = true;
                            break;
                        }
                    }
                }

                dispatch(setMCRCUploadedFile(hasUploadedFile));
            }

            // check if regional user has uploaded file
            if (userInfo.Billet.location === 'Regional') {
                let hasUploadedFile = false;
                if (formData.Photos.length > 0) {
                    const eventItems = formData.Photos.filter(
                        item => item.resourceType === 'Event'
                    );
                    for (let i = 0; i < eventItems.length; i += 1) {
                        const doc = eventItems[i];
                        if (doc.createdById === userInfo.id) {
                            hasUploadedFile = true;
                            break;
                        }
                    }
                } else if (!hasUploadedFile && formData.Documents.length > 0) {
                    const eventItems = formData.Documents.filter(
                        item => item.resourceType === 'Event'
                    );
                    for (let i = 0; i < eventItems.length; i += 1) {
                        const doc = eventItems[i];
                        if (doc.createdById === userInfo.id) {
                            hasUploadedFile = true;
                            break;
                        }
                    }
                }

                dispatch(setRegionalUploadedFile(hasUploadedFile));
            }
            // check if district user has uploaded file
            if (userInfo.Billet.location === 'District') {
                let hasUploadedFile = false;
                if (formData.Photos.length > 0) {
                    const eventItems = formData.Photos.filter(
                        item => item.resourceType === 'Event'
                    );
                    for (let i = 0; i < eventItems.length; i += 1) {
                        const doc = eventItems[i];
                        if (doc.createdById === userInfo.id) {
                            hasUploadedFile = true;
                            break;
                        }
                    }
                } else if (!hasUploadedFile && formData.Documents.length > 0) {
                    const eventItems = formData.Documents.filter(
                        item => item.resourceType === 'Event'
                    );
                    for (let i = 0; i < eventItems.length; i += 1) {
                        const doc = eventItems[i];
                        if (doc.createdById === userInfo.id) {
                            hasUploadedFile = true;
                            break;
                        }
                    }
                }

                dispatch(setDistrictUploadedFile(hasUploadedFile));
            }

            /*
             * Check against the selected document to see if the user can perform
             * any actions on it.
             *
             * This code may be obsolete
             * TODO: Check through event components and remove instances of this
             */
            if (formData.status === 'Incomplete') {
                dispatch(setEventActions(true));
                dispatch(setEventAfterActionsMod(false));
            } else if (formData.status === 'Unapproved') {
                if (userInfo.id === formData.approverId) {
                    dispatch(setEventActions(true));
                    dispatch(setEventAfterActionsMod(false));
                }
            } else if (formData.status === 'Approved') {
                if (userIsCreator || userInfo.id === formData.approverId) {
                    dispatch(setEventAfterActionsMod(true));
                } else {
                    dispatch(setEventAfterActionsMod(false));
                }
            } else {
                dispatch(setEventActions(false));
                dispatch(setEventAfterActionsMod(false));
            }

            // Check if an MPA/MAC recommendation exists
            if (formData.recommend === true) {
                dispatch(setShowEventRecommend(true));
                dispatch(setEventRecommended(true));
                formData.recommend = '1';
            } else if (formData.recommendReason) {
                dispatch(setShowEventRecommend(true));
                formData.recommend = '0';
                dispatch(setEventRecommended(false));
            } else {
                dispatch(setShowEventRecommend(false));
                dispatch(setEventRecommended(true));
                delete formData.recommend;
                delete formData.recommendReason;
            }

            if (formData.cost <= 0) {
                formData.cost = '0';
                formData.freeEvent = '1';
            }

            formData.eventFile = [];

            // Load the current form data into the events object.
            dispatch(actions.load('event', formData));
            dispatch(actions.resetValidity('event'));

            //Set the status and substatus of the event
            let groupStatus = getStatus(
                formData.status,
                formData.subStatus,
                formData.EventReport,
                formData.startDate
            );

            dispatch(setGroupStatus(groupStatus.status, groupStatus.subStatus));

            // dispatch(fetchEventTaskThunk(formData.id, formData.cost));
            if (formData.reportId) {
                dispatch(
                    fetchTasksThunk(
                        formData.id,
                        formData.reportId,
                        formData.cost
                    )
                );
            } else {
                dispatch(fetchTasksThunk(formData.id, false, formData.cost));
            }
            // Set information used in Event display logic
            dispatch(setEventId(formData.id));
            // dispatch(
            //     setEventName(
            //         `${formData.name} ${formData.sDate.format('YYYY-MM-DD')}`
            //     )
            // );
            dispatch(setEventName(formData.qualifiedName));

            dispatch(setEventStartDate(formData.sDate));

            // Calculate what actions a user can take on this event
            dispatch(calcEventSaveSubmit());
            dispatch(calcEventApproveReject());
            dispatch(calcPRSaveSubmit());

            // Fetch After Action notes
            dispatch(fetchAANoteThunk(formData.id));
            if (formData.EventComments && formData.EventComments.length > 0) {
                dispatch(setRejectComments(formData.EventComments[0].comments));
            } else {
                dispatch(setRejectComments(formData.rejectComments));
            }

            dispatch(loadInitialPromoItems(formData.PromotionalItem));
            for (let i = 0; i < formData.PromotionalItem.length; i++) {
                let item = formData.PromotionalItem[i];
                dispatch(addPromoItems(item));
            }
            dispatch(setApproverState(false));

            // let afterActionStatus = [
            //     'After Action Pending',
            //     'After Action Incomplete',
            //     'After Action Review'
            // ];
            // afterActionStatus.includes(groupStatus.status) &&

            //If this event is in after action status
            if (
                formData.status === 'Approved' &&
                formData.startDate &&
                moment(formData.startDate).isSameOrBefore(moment())
            ) {
                history.push('/event/after-action');
            }
            // dispatch(fetchEventApprovers(formData.cost));
            dispatch(fetchEventLoadingSuccess());
        }
    });
};

export const setFormFieldValidity = (model, bool) => dispatch => {
    dispatch(actions.setValidity(model, bool));
    dispatch(actions.setTouched(model, true));
};

export const setGroupStatus = (status, subStatus) => ({
    type: types.EVENT_GROUP_STATUS,
    groupStatus: {
        status,
        subStatus
    }
});

export const getEventReportMediaThunk = id => (dispatch, getState) => {
    apiRequest(
        `${
            endpoints.BASE_EVENT_REPORT_PATH
        }/${id}?include[]=Documents&include[]=Photos`,
        getState().auth.jwtToken
    ).then(payload => {
        if (payload.errors) {
        } else {
            let data = payload.data[0];
            let docs = data.Documents;
            let photos = data.Photos;
            for (let i = 0; i < docs.length; i++) {
                let item = docs[i];
                dispatch(uploadedFiles(item));
            }
            for (let i = 0; i < photos.length; i++) {
                let item = photos[i];
                dispatch(uploadedFiles(item));
            }
        }
    });
};

export const fetchPurchaseRequestLoading = () => {
    return {
        type: types.PR_LOADING
    };
};

export const fetchPurchaseRequestLoadingSuccess = () => {
    return {
        type: types.PR_LOADING_SUCCESS
    };
};

export const fetchPurchaseRequestThunk = id => (dispatch, getState) => {
    dispatch(fetchPurchaseRequestLoading());
    apiRequest(
        `${
            endpoints.EVENT_DETAIL_PATH
        }/${id}?include[]=PurchaseRequest&include[]=Vendor`,
        getState().auth.jwtToken
    ).then(payload => {
        if (payload.data[0].PurchaseRequest) {
            const purchaseRequestId = payload.data[0].PurchaseRequest.id;
            apiRequest(
                `${
                    endpoints.PURCHASE_REQUEST
                }/${purchaseRequestId}?include[]=PurchaseRequestItem&include[]=Documents&include[]=Photos`,
                getState().auth.jwtToken
            ).then(payload => {
                if (payload.errors) {
                    console.log(payload);
                } else {
                    const purchaseRequestPayload = payload.data[0];
                    const formattedDate = moment(
                        purchaseRequestPayload.createdAt
                    );
                    const formattedRequiredDate = moment(
                        purchaseRequestPayload.dateRequired
                    );
                    if (formattedDate._isValid) {
                        purchaseRequestPayload.createdAt = formattedDate;
                    }
                    if (formattedRequiredDate._isValid) {
                        purchaseRequestPayload.dateRequired = formattedRequiredDate;
                    }
                    purchaseRequestPayload.newItem = {
                        purchaseRequestId: purchaseRequestPayload.id,
                        unitOfIssue: 'EACH'
                    };
                    dispatch(
                        actions.load('PurchaseRequest', purchaseRequestPayload)
                    );
                }
                dispatch(fetchPurchaseRequestLoadingSuccess());
            });
        } else {
            dispatch(fetchPurchaseRequestLoadingSuccess());
        }
    });
};

export const handlePurchaseRequestMedia = (prID, media) => (
    dispatch,
    getState
) => {
    let id = prID;
    const documents = media
        .filter(item => item.mediaType === 'Document')
        .map(item => item.id);

    const photos = media
        .filter(item => item.mediaType === 'Image')
        .map(item => item.id);
    apiRequest(
        `${endpoints.PURCHASE_REQUEST}/update`,
        getState().auth.jwtToken,
        'POST',
        JSON.stringify({
            data: { id: id, Documents: documents, Photos: photos }
        })
    ).then(response => {
        console.log(response);
    });
};

export const setPurchaseRequestEventId = id => dispatch => {
    dispatch(actions.change('PurchaseRequest.eventId', id));
};

export const setPurchaseRequestItemId = id => dispatch => {
    dispatch(actions.change('PurchaseRequest.newItem.purchaseRequestId', id));
};

export const setCreatedPrId = id => dispatch => {
    dispatch(actions.change('PurchaseRequest.id', id));
};

export const updatePurchaseRequestItemId = (index, id) => dispatch => {
    dispatch(
        actions.change(
            `PurchaseRequest.PurchaseRequestItem[${index}].purchaseRequestId`,
            id
        )
    );
};

export const updateTotalAmount = amount => dispatch => {
    dispatch(actions.change('PurchaseRequest.itemizedCost', amount));
};

export const updateTotalLine = (index, amount) => dispatch => {
    dispatch(
        actions.change(
            `PurchaseRequest.PurchaseRequestItem[${index}].total`,
            amount
        )
    );
};

export const updateTotalNewLine = amount => dispatch => {
    dispatch(actions.change('PurchaseRequest.newItem.total', amount));
};

export const updateLineItems = object => dispatch => {
    dispatch(actions.push('PurchaseRequest.PurchaseRequestItem[]', object));
};

export const clearLineItem = object => dispatch => {
    dispatch(actions.load('PurchaseRequest.newItem', object));
};

export const removeLineItem = index => dispatch => {
    dispatch(actions.remove('PurchaseRequest.PurchaseRequestItem[]', index));
};

export const setEventId = id => {
    return {
        type: types.SET_EVENT_ID,
        id
    };
};

export const setEventName = name => {
    return {
        type: types.SET_EVENT_NAME,
        name
    };
};

export const setEventStartDate = date => {
    return {
        type: types.SET_EVENT_START_DATE,
        date
    };
};

export const setCurrentReviewerId = id => {
    return {
        type: types.SET_CURRENT_REVIEWER_ID,
        id
    };
};

export const setEventActions = hasActions => {
    return {
        type: types.SET_EVENT_ACTIONS,
        hasActions
    };
};

export const setUserIsCreator = userIsCreator => {
    return {
        type: types.SET_USER_IS_CREATOR,
        userIsCreator
    };
};

export const fetchEventSuccess = status => {
    return {
        type: types.SET_EVENT_STATUS,
        status
    };
};

export const setEventSuccessMessage = message => {
    return {
        type: types.SET_EVENT_SUCCESS_MESSAGE,
        message
    };
};

export const setEventErrorMessage = message => (dispatch, getState) => {
    if (message === 'Invalid token') {
        //Redirects them to adportal
        dispatch(unAuthUser);
    } else {
        dispatch(errorMessageDefault(message));
    }
};

export const errorMessageDefault = message => {
    return {
        type: types.SET_EVENT_ERROR_MESSAGE,
        message
    };
};
// fetchTasksThunks is for use in FetchEventThunk to get tasks so that it will be available for approvers call.

export const fetchTasksThunk = (id, aaId, cost) => (dispatch, getState) => {
    if (aaId) {
        const p1 = apiRequest(
            `${endpoints.TASK_PATH}/search?resourceId=${id}&resourceType=Event`,
            getState().auth.jwtToken
        ).then(payload => {
            if (payload.data) {
                if (payload.data.length > 0) {
                    const userInfo = getState().data.userInfo;
                    if (
                        parseInt(userInfo.id, 10) ===
                        parseInt(payload.data[0].userId, 10)
                    ) {
                        dispatch(setEventActions(true));
                    } else {
                        dispatch(setEventActions(false));
                    }
                }
                dispatch(fetchEventTaskSuccess(payload.data));
                dispatch(calcEventSaveSubmit());
                dispatch(calcEventApproveReject());
                dispatch(calcPRSaveSubmit());
                dispatch(eventActionOverlaySuccess());
            }
        });
        const p2 = apiRequest(
            `${
                endpoints.TASK_PATH
            }/search?resourceId=${aaId}&resourceType=EventReport`,
            getState().auth.jwtToken
        ).then(payload => {
            if (payload.data) {
                if (payload.data.length > 0) {
                    const userInfo = getState().data.userInfo;
                    if (
                        parseInt(userInfo.id, 10) ===
                        parseInt(payload.data[0].userId, 10)
                    ) {
                        dispatch(setEventActions(true));
                    } else {
                        dispatch(setEventActions(false));
                    }
                }
                dispatch(fetchAATaskSuccess(payload.data));
                if (payload.data.length > 0) {
                    const mostRecentTask = last(sortBy(payload.data, 'id'));
                    if (getState().data.userInfo.id === mostRecentTask.userId) {
                        dispatch(setEventAfterActionsMod(true));
                    } else {
                        dispatch(setEventAfterActionsMod(false));
                    }

                    if (mostRecentTask.action === 'Info') {
                        dispatch(fetchAACommentsThunk(id));
                    }
                }
            }
        });
        Promise.all([p1, p2]).then(() => {
            dispatch(fetchEventApprovers(cost));
        });
    } else {
        apiRequest(
            `${endpoints.TASK_PATH}/search?resourceId=${id}&resourceType=Event`,
            getState().auth.jwtToken
        ).then(payload => {
            if (payload.data) {
                if (payload.data.length > 0) {
                    const userInfo = getState().data.userInfo;
                    if (
                        parseInt(userInfo.id, 10) ===
                        parseInt(payload.data[0].userId, 10)
                    ) {
                        dispatch(setEventActions(true));
                    } else {
                        dispatch(setEventActions(false));
                    }
                }
                dispatch(fetchEventTaskSuccess(payload.data));
                if (typeof cost === 'number') {
                    dispatch(eventCost(cost, false));
                    dispatch(fetchEventApprovers(cost));
                } else {
                    dispatch(fetchEventApprovers(0));
                }
                dispatch(calcEventSaveSubmit());
                dispatch(calcEventApproveReject());
                dispatch(calcPRSaveSubmit());
                dispatch(eventActionOverlaySuccess());
            }
        });
    }
};

export const fetchEventTaskThunk = id => (dispatch, getState) => {
    apiRequest(
        `${endpoints.TASK_PATH}/search?resourceId=${id}&resourceType=Event`,
        getState().auth.jwtToken
    ).then(payload => {
        if (payload.data) {
            if (payload.data.length > 0) {
                const userInfo = getState().data.userInfo;
                if (
                    parseInt(userInfo.id, 10) ===
                    parseInt(payload.data[0].userId, 10)
                ) {
                    dispatch(setEventActions(true));
                } else {
                    dispatch(setEventActions(false));
                }
            }
            dispatch(fetchEventTaskSuccess(payload.data));
            dispatch(calcEventSaveSubmit());
            dispatch(calcEventApproveReject());
            dispatch(calcPRSaveSubmit());
            dispatch(eventActionOverlaySuccess());
            // This is already happening on fetchEvent and this function would be called again. NO NO!
            // dispatch(fetchEventApprovers(eventCost));
        }
    });
};

export const fetchAATaskThunk = id => (dispatch, getState) => {
    apiRequest(
        `${
            endpoints.TASK_PATH
        }/search?resourceId=${id}&resourceType=EventReport`,
        getState().auth.jwtToken
    ).then(payload => {
        if (payload.data) {
            if (payload.data.length > 0) {
                const userInfo = getState().data.userInfo;
                if (
                    parseInt(userInfo.id, 10) ===
                    parseInt(payload.data[0].userId, 10)
                ) {
                    dispatch(setEventActions(true));
                } else {
                    dispatch(setEventActions(false));
                }
            }
            dispatch(fetchAATaskSuccess(payload.data));
            if (payload.data.length > 0) {
                const mostRecentTask = last(sortBy(payload.data, 'id'));
                if (getState().data.userInfo.id === mostRecentTask.userId) {
                    dispatch(setEventAfterActionsMod(true));
                } else {
                    dispatch(setEventAfterActionsMod(false));
                }

                if (mostRecentTask.action === 'Info') {
                    dispatch(fetchAACommentsThunk(id));
                }
            }
            return true;
        }
    });
};

export const fetchEventTaskSuccess = tasks => {
    return {
        type: types.SET_EVENT_TASKS,
        tasks
    };
};

export const fetchAATaskSuccess = tasks => {
    return {
        type: types.SET_AA_TASKS,
        tasks
    };
};

export const rejectEventThunk = data => (dispatch, getState) => {
    dispatch(eventActionOverlayLoading('Rejecting Event'));
    apiRequest(
        `${endpoints.EVENT_DETAIL_PATH}/reject?id=${data.id}`,
        getState().auth.jwtToken,
        'POST',
        JSON.stringify({ data })
    ).then(payload => {
        if (payload.errors) {
            if (Array.isArray(payload.errors[0].detail)) {
                dispatch(
                    setEventErrorMessage(payload.errors[0].detail[0].detail)
                );
            } else {
                dispatch(setEventErrorMessage(payload.errors[0].detail));
            }
        } else {
            dispatch(clearAllErrors());
            dispatch(setRejectComments(payload.data.rejectComments));
            dispatch(rejectEventSuccess());
            dispatch(fetchEventTaskThunk(getState().events.id));
            dispatch(fetchEventSuccess('Rejected'));
            dispatch(calcEventSaveSubmit());
            dispatch(calcEventApproveReject());
        }
        dispatch(eventActionOverlaySuccess());
    });
};

export const setRejectComments = rejectComments => {
    return {
        type: types.SET_REJECT_COMMENTS,
        rejectComments
    };
};

export const rejectEventSuccess = () => {
    return {
        type: types.SET_EVENT_STATUS,
        status: 'Rejected'
    };
};

export const approveEventThunk = data => (dispatch, getState) => {
    // might have show that it was trusted user or normal user. brent confirming with audrey/avri.
    // update: need to record the trusted users id in the approval process. don't need to do anything.
    let postBody = JSON.stringify({ data: { id: data.id } });
    if (data.approverId) {
        postBody = JSON.stringify({
            data: { id: data.id, next: data.approverId }
        });
    }
    dispatch(eventActionOverlayLoading('Approving Event'));
    apiRequest(
        `${endpoints.EVENT_DETAIL_PATH}/approve`,
        getState().auth.jwtToken,
        'POST',
        postBody
    ).then(payload => {
        if (payload.errors) {
            if (Array.isArray(payload.errors[0].detail)) {
                dispatch(
                    setEventErrorMessage(payload.errors[0].detail[0].detail)
                );
            } else {
                dispatch(setEventErrorMessage(payload.errors[0].detail));
            }
        } else {
            dispatch(clearAllErrors());
            dispatch(approveEventSuccess());
            dispatch(
                setEventSuccessMessage(
                    `Event approved at ${moment().format(
                        'YYYY-MM-DD HH:MM:SS'
                    )}.`
                )
            );

            if (payload.data.status && payload.data.status === 'Approved') {
                dispatch(fetchEventSuccess('Approved'));
            } else {
                dispatch(fetchEventSuccess('Pending'));
            }
            dispatch(calcEventSaveSubmit());
            dispatch(calcEventApproveReject());
            dispatch(calcPRSaveSubmit());
            dispatch(setApproverState(true));
        }
        dispatch(eventActionOverlaySuccess());
    });
};

export const approveEventSuccess = () => {
    return {
        type: types.SET_EVENT_STATUS,
        status: 'Approved'
    };
};

export const requestInfoEventThunk = data => (dispatch, getState) => {
    dispatch(eventActionOverlayLoading('Returned For Edit'));
    apiRequest(
        `${endpoints.EVENT_DETAIL_PATH}/requestinfo?id=${data.id}`,
        getState().auth.jwtToken,
        'POST',
        JSON.stringify({ data })
    ).then(payload => {
        if (payload.errors) {
            if (Array.isArray(payload.errors[0].detail)) {
                dispatch(
                    setEventErrorMessage(payload.errors[0].detail[0].detail)
                );
            } else {
                dispatch(setEventErrorMessage(payload.errors[0].detail));
            }
        } else {
            let userInfo = getState().data.userInfo;

            const commentObj = {
                eventId: payload.data.resourceId,
                comments: payload.data.comments,
                rank: userInfo.rank,
                firstName: userInfo.firstName,
                lastName: userInfo.lastName
            };
            dispatch(setEventCommentThunk(commentObj));
            dispatch(clearAllErrors());
            dispatch(fetchEventTaskThunk(getState().events.id));
            dispatch(fetchEventSuccess('Pending'));
            dispatch(setRejectComments(payload.data.comments));
            dispatch(calcEventSaveSubmit());
            dispatch(calcEventApproveReject());
            dispatch(
                setEventSuccessMessage(
                    `Event information requested at ${moment().format(
                        'YYYY-MM-DD HH:MM:SS'
                    )}.`
                )
            );
        }
        dispatch(eventActionOverlaySuccess());
    });
};

export const setEventCommentThunk = data => (dispatch, getState) => {
    apiRequest(
        `${endpoints.EVENT_COMMENT_PATH}/create`,
        getState().auth.jwtToken,
        'POST',
        JSON.stringify({ data })
    ).then(payload => {
        if (payload.errors) {
            console.log(payload);
        }
    });
};

export const createAACommentThunk = data => (dispatch, getState) => {
    dispatch(eventActionOverlayLoading('Create After Action Comment'));
    apiRequest(
        `${endpoints.EVENT_REPORT_COMMENT_PATH}/create`,
        getState().auth.jwtToken,
        'POST',
        JSON.stringify({ data })
    ).then(payload => {
        if (payload.errors) {
            console.log(payload);
        }
        dispatch(eventActionOverlaySuccess());
    });
};

export const createVendorThunk = (eventId, vendors) => (dispatch, getState) => {
    let vendorsToCreate = vendors.length;
    const newVendorIds = [];
    for (let i = 0; i < vendors.length; i += 1) {
        const data = vendors[i];
        apiRequest(
            `${endpoints.VENDOR_PATH}/create`,
            getState().auth.jwtToken,
            'POST',
            JSON.stringify({ data })
            // eslint-disable-next-line
        ).then(payload => {
            vendorsToCreate -= 1;
            newVendorIds.push(payload.data.id);
            if (vendorsToCreate === 0) {
                dispatch(updateEventWithVendors(eventId, newVendorIds));
            }
        });
    }
};

export const updateEventWithVendors = (eventId, vendorIds) => (
    dispatch,
    getState
) => {
    apiRequest(
        `${endpoints.EVENT_DETAIL_PATH}/update`,
        getState().auth.jwtToken,
        'POST',
        JSON.stringify({ data: { id: eventId, Vendor: vendorIds } })
    ).then(payload => {
        dispatch(clearAllErrors());
        dispatch(
            setEventSuccessMessage(
                `Event updated at ${moment().format('YYYY-MM-DD HH:MM:SS')}.`
            )
        );
    });
};

export const updateEventThunk = data => (dispatch, getState) => {
    if (!!getState().event.category) {
        if (getState().event.category.length > 0) {
            let category = getState().event.category.map(item => item.value);
            data.Category = category;
        }
    }
    dispatch(eventActionOverlayLoading('Update Event'));
    apiRequest(
        `${endpoints.EVENT_DETAIL_PATH}/update`,
        getState().auth.jwtToken,
        'POST',
        JSON.stringify({ data })
    ).then(payload => {
        if (payload.errors) {
            if (Array.isArray(payload.errors[0].detail)) {
                dispatch(
                    setEventErrorMessage(payload.errors[0].detail[0].detail)
                );
            } else {
                dispatch(setEventErrorMessage(payload.errors[0].detail));
            }
        } else {
            //Only is set when the assignee has a value
            if (getState().event.assignee) {
                dispatch(
                    assignAssigneeAfterAction(
                        payload.data.id,
                        getState().event.assignee
                    )
                );
            }

            const storedVendors = getState().events.storedVendors;
            if (storedVendors.length > 0) {
                const eventId = payload.data.id;
                for (let i = 0; i < storedVendors.length; i += 1) {
                    const vendor = storedVendors[i];
                    const vendorObj = {
                        vendor: vendor.id,
                        event: eventId
                    };
                    dispatch(assignVendorItem(vendorObj));
                }
                dispatch(clearVendorItems());
            } else {
                dispatch(clearAllErrors());
                dispatch(
                    setEventSuccessMessage(
                        `Event updated at ${moment().format(
                            'YYYY-MM-DD HH:MM:SS'
                        )}.`
                    )
                );
            }

            const onsiteDates = getState().ui.onSiteAddDates;
            if (onsiteDates.length > 0) {
                for (let i = 0; i < onsiteDates.length; i += 1) {
                    const item = onsiteDates[i];
                    let dateObj = {
                        date: item.date,
                        eventId: payload.data.id
                    };
                    if (item.id) {
                        dateObj.id = item.id;
                        dispatch(updateOnsiteDateThunk(dateObj));
                    } else {
                        dispatch(createOnsiteDateThunk(dateObj));
                    }
                }
            }
            dispatch(attachedDocumentsThunk(data));
        }
        dispatch(eventActionOverlaySuccess());
        dispatch(calcPRSaveSubmit());
    });
};

export const attachedDocumentsThunk = data => (dispatch, getState) => {
    const eventFiles = getState().event.eventFile;
    if (eventFiles.length > 0) {
        eventFiles.forEach(item => {
            const fileUpload = {
                eventId: data.id,
                id: item,
                type: 'Event'
            };
            dispatch(associateUploadedFile(fileUpload, true));
        });
        dispatch(actions.reset('event.eventFile'));
    }

    return true;
};

export const createEventAttachedDocumentsThunk = data => (
    dispatch,
    getState
) => {
    const eventFiles = getState().event.eventFile;
    if (eventFiles.length > 0) {
        eventFiles.forEach(item => {
            const fileUpload = {
                eventId: data,
                id: item,
                type: 'Event'
            };
            dispatch(associateUploadedFile(fileUpload, true));
        });
        dispatch(actions.reset('event.eventFile'));
    }

    return true;
};

export const handleEventVendorActions = (eventId, vendorItems) => dispatch => {
    const newVendorItems = vendorItems.filter(item => !item.id);
    if (newVendorItems.length > 0) {
        dispatch(createVendorThunk(eventId, newVendorItems));
    }
    const existingVendorItems = vendorItems
        .filter(item => item.id)
        .map(item => item.id);
    if (existingVendorItems.length > 0) {
        dispatch(updateEventWithVendors(eventId, existingVendorItems));
    }
};

export const updateAndSubmitEventThunk = data => (dispatch, getState) => {
    dispatch(eventActionOverlayLoading('Update And Submit Event'));
    apiRequest(
        `${endpoints.EVENT_DETAIL_PATH}/update`,
        getState().auth.jwtToken,
        'POST',
        JSON.stringify({ data })
    ).then(payload => {
        if (payload.errors) {
            if (Array.isArray(payload.errors[0].detail)) {
                dispatch(
                    setEventErrorMessage(payload.errors[0].detail[0].detail)
                );
            } else {
                dispatch(setEventErrorMessage(payload.errors[0].detail));
            }
        } else {
            dispatch(clearAllErrors());
            dispatch(
                setEventSuccessMessage(
                    `Event updated at ${moment().format('YYYY-MM-DD HH:MM:SS')}`
                )
            );

            //Only is set when the assignee has a value
            if (getState().event.assignee) {
                dispatch(
                    assignAssigneeAfterAction(
                        payload.data.id,
                        getState().event.assignee
                    )
                );
            }

            const storedVendors = getState().events.storedVendors;
            if (storedVendors.length > 0) {
                const eventId = payload.data.id;
                for (let i = 0; i < storedVendors.length; i += 1) {
                    const vendor = storedVendors[i];
                    const vendorObj = {
                        vendor: vendor.id,
                        event: eventId
                    };
                    dispatch(assignVendorItem(vendorObj));
                }
                dispatch(clearVendorItems());
            }

            const onsiteDates = getState().ui.onSiteAddDates;
            if (onsiteDates.length > 0) {
                for (let i = 0; i < onsiteDates.length; i += 1) {
                    const item = onsiteDates[i];
                    let dateObj = {
                        date: item.date,
                        eventId: payload.data.id
                    };
                    if (item.id) {
                        dateObj.id = item.id;
                        dispatch(updateOnsiteDateThunk(dateObj));
                    } else {
                        dispatch(createOnsiteDateThunk(dateObj));
                    }
                }
            }

            dispatch(attachedDocumentsThunk(data));

            dispatch(submitEventThunk(data));
        }
    });
};

export const updateAndApproveEventThunk = data => (dispatch, getState) => {
    let hasRecommend = true;
    if (
        getState().data.userInfo.Billet.name === 'MPA' ||
        getState().data.userInfo.Billet.name === 'MAC'
    ) {
        if (!data.recommend) {
            hasRecommend = false;
            dispatch(setEventErrorMessage('Please provide a recommendation.'));
        } else if (data.recommend === '0') {
            if (!data.recommendReason) {
                hasRecommend = false;
                dispatch(
                    setEventErrorMessage(
                        'Please provide a reason you would not recommend this event.'
                    )
                );
            }
        }
    }

    dispatch(eventActionOverlayLoading('Update To Get Event Approve'));
    if (hasRecommend) {
        apiRequest(
            `${endpoints.EVENT_DETAIL_PATH}/update`,
            getState().auth.jwtToken,
            'POST',
            JSON.stringify({ data })
        ).then(payload => {
            if (payload.errors) {
                if (Array.isArray(payload.errors[0].detail)) {
                    dispatch(
                        setEventErrorMessage(payload.errors[0].detail[0].detail)
                    );
                } else {
                    dispatch(setEventErrorMessage(payload.errors[0].detail));
                }
            } else {
                dispatch(
                    setEventSuccessMessage(
                        `Event updated at ${moment().format(
                            'YYYY-MM-DD HH:MM:SS'
                        )}.`
                    )
                );
                dispatch(approveEventThunk(data));
            }
            dispatch(eventActionOverlaySuccess());
            dispatch(setApproverState(true));
        });
    }
};

//Do not think we need this anymore we are linking straight from index
export const deleteEventThunk = id => (dispatch, getState) => {
    const data = { id: getState().events.id };
    dispatch(eventActionOverlayLoading('Delete Event'));
    apiRequest(
        `${endpoints.EVENT_DETAIL_PATH}/delete/${data.id}`,
        getState().auth.jwtToken,
        'POST',
        JSON.stringify({ data })
    ).then(payload => {
        if (payload.errors) {
            if (Array.isArray(payload.errors[0].detail)) {
                dispatch(
                    setEventErrorMessage(payload.errors[0].detail[0].detail)
                );
            } else {
                dispatch(setEventErrorMessage(payload.errors[0].detail));
            }
        } else {
            dispatch(
                setEventSuccessMessage(
                    `Event deleted at ${moment().format(
                        'YYYY-MM-DD HH:MM:SS'
                    )}.`
                )
            );
            dispatch(resetEvent());
        }
        dispatch(eventActionOverlaySuccess());
    });
};

export const updateFundedDistrictSuccess = payload => ({
    type: types.UPDATE_FUNDED_DISTRICT_SUCCESS,
    payload
});

export const updateFundedRSSuccess = payload => ({
    type: types.UPDATE_FUNDED_RS_SUCCESS,
    payload
});

export const updateFundedRSSSuccess = payload => ({
    type: types.UPDATE_FUNDED_RSS_SUCCESS,
    payload
});

export const updateFundedDistrict = (e, fromForm = true) => (
    dispatch,
    getState
) => {
    let region = e;
    if (fromForm) {
        region = e.target.value;
    }
    apiRequest(
        `${endpoints.LOCATION_DISTRICT_LIST}${region}`,
        getState().auth.jwtToken
    ).then(payload => {
        dispatch(updateFundedDistrictSuccess(payload.data));
    });
};

export const updateFundedRS = (e, fromForm = true) => (dispatch, getState) => {
    let districtCode = e;
    if (fromForm) {
        districtCode = e.target.value;
    }
    apiRequest(
        `${endpoints.LOCATION_RS_LIST}${districtCode}`,
        getState().auth.jwtToken
    ).then(payload => {
        dispatch(updateFundedRSSuccess(payload.data));
    });
};

export const updateFundedOSS = rsCode => (dispatch, getState) => {
    apiRequest(
        `${endpoints.LOCATION_OSS_LIST}${rsCode}`,
        getState().auth.jwtToken
    ).then(payload => {
        dispatch(
            updateFundedRSSSuccess(
                searchFormat.formatOSSRSSDropdown(payload.data)
            )
        );
    });
};

export const updateFundedRSS = (e, fromForm = true) => (dispatch, getState) => {
    let rsCode = e;
    if (fromForm) {
        rsCode = e.target.value;
    }
    if (getState().data.userInfo.OSS) {
        apiRequest(
            `${endpoints.LOCATION_OSS_LIST}${rsCode}`,
            getState().auth.jwtToken
        ).then(payload => {
            dispatch(
                updateFundedRSSSuccess(
                    searchFormat.formatOSSRSSDropdown(payload.data)
                )
            );
        });
    } else if (getState().data.userInfo.RSS) {
        apiRequest(
            `${endpoints.LOCATION_RSS_LIST}${rsCode}`,
            getState().auth.jwtToken
        ).then(payload => {
            dispatch(
                updateFundedRSSSuccess(
                    searchFormat.formatOSSRSSDropdown(payload.data)
                )
            );
        });
    } else {
        apiRequest(
            `${endpoints.LOCATION_RSS_LIST}${rsCode}`,
            getState().auth.jwtToken
        ).then(payload => {
            let RssList = payload.data;
            apiRequest(
                `${endpoints.LOCATION_OSS_LIST}${rsCode}`,
                getState().auth.jwtToken
            ).then(payload => {
                dispatch(
                    updateFundedRSSSuccess(
                        searchFormat.formatOSSRSSDropdown(
                            payload.data.concat(RssList)
                        )
                    )
                );
            });
        });
    }
};

export const freeEvent = e => dispatch => {
    dispatch(actions.change('event.cost', '0'));
};

export const eventCost = (e, fromForm = true) => dispatch => {
    let cost = e;
    if (fromForm) {
        cost = e.target.value;
    }

    if (cost > 0) {
        dispatch(actions.change('event.freeEvent[]', ''));
    }

    dispatch(calcPRAccessible());
};

export const vendorInformation = object => dispatch => {
    dispatch(actions.push('event.vendorsInformation[]', object));
};

export const vendorInformationLoad = object => dispatch => {
    dispatch(actions.load('event.vendorForm', object));
};

export const vendorInformationRemove = index => (dispatch, getState) => {
    let eventId = getState().event.id;
    let vendorId = getState().event.vendorsInformation[index].id;
    //Delete endpoint
    apiRequest(
        `${endpoints.EVENT_VENDOR_PATH}/delete`,
        getState().auth.jwtToken,
        'POST',
        JSON.stringify({
            data: { vendor: vendorId, event: eventId }
        })
    ).then(payload => {
        if (payload.errors) {
            if (Array.isArray(payload.errors[0].detail)) {
                dispatch(
                    setEventErrorMessage(payload.errors[0].detail[0].detail)
                );
            } else {
                dispatch(setEventErrorMessage(payload.errors[0].detail));
            }
        } else {
            dispatch(actions.remove('event.vendorsInformation[]', index));
        }
    });
};

export const uploadedFiles = object => dispatch => {
    dispatch(actions.push('event.uploadedFiles[]', object));
};

export const removeUploadedFiles = (index, data) => (dispatch, getState) => {
    apiRequest(
        `${endpoints.MEDIA}/delete`,
        getState().auth.jwtToken,
        'POST',
        JSON.stringify({
            data: { id: data.id }
        })
    ).then(payload => {
        console.log(payload);
    });
    dispatch(actions.remove('event.uploadedFiles[]', index));
};

export const removeDocumentFiles = (index, data) => (dispatch, getState) => {
    apiRequest(
        `${endpoints.MEDIA}/delete`,
        getState().auth.jwtToken,
        'POST',
        JSON.stringify({
            data: { id: data.id }
        })
    ).then(payload => {
        dispatch(removeDocumentSuccess(data.id));
        dispatch(actions.remove('event.eventFile[]', index));
    });
};

export const removeDocumentSuccess = id => ({
    type: types.REMOVE_DOCUMENT_SUCCESS,
    id
});

export const associateUploadedFile = (data, attachedDocuments = false) => (
    dispatch,
    getState
) => {
    let file = data.id;
    let type = data.type;
    let eventId = data.eventId;
    apiRequest(
        `${endpoints.MEDIA}/update`,
        getState().auth.jwtToken,
        'POST',
        JSON.stringify({
            data: { id: file, resourceType: type, resourceId: eventId }
        })
    ).then(payload => {
        console.log(payload);

        //Update the path on save and or submit of event details attached documents
        if (attachedDocuments) {
            const eventFiles = getState().events.eventFiles;
            eventFiles.forEach(item => {
                if (payload.data.id === item.id) {
                    dispatch(updateEventUploads(payload.data));
                }
            });
        }
    });
};

export const updateEventUploads = data => ({
    type: types.UPDATE_ATTACHED_DOCUMENTS,
    data
});

export const promotionalItem = data => (dispatch, getState) => {
    if (data.PromotionalItem) {
        let eventId = getState().events.id;
        let promoItems = data.PromotionalItem;
        dispatch(handlePromoItemsThunk(eventId, promoItems));
    }

    return true;
};

export const updateAfterAction = data => (dispatch, getState) => {
    dispatch(eventActionOverlayLoading('Update After Action'));
    Promise.all([dispatch(promotionalItem(data))]).then(() => {
        if (data.aaawareness || data.aabehavior) {
            data.awareness = data.aaawareness;
            data.behavior = data.aabehavior;
        }

        apiRequest(
            `${endpoints.BASE_EVENT_REPORT_PATH}/update`,
            getState().auth.jwtToken,
            'POST',
            JSON.stringify({ data })
        ).then(payload => {
            if (payload.errors) {
                if (Array.isArray(payload.errors[0].detail)) {
                    dispatch(
                        setEventErrorMessage(payload.errors[0].detail[0].detail)
                    );
                } else {
                    dispatch(setEventErrorMessage(payload.errors[0].detail));
                }
            } else {
                dispatch(clearAllErrors());
                dispatch(
                    setEventSuccessMessage(
                        `After Action updated at ${moment().format(
                            'YYYY-MM-DD HH:MM:SS'
                        )}.`
                    )
                );
            }
            dispatch(eventActionOverlaySuccess());
        });
    });
};

export const updateAndSubmitAfterAction = data => (dispatch, getState) => {
    dispatch(eventActionOverlayLoading('Update and Submit After Action'));

    Promise.all([dispatch(promotionalItem(data))]).then(() => {
        if (data.aaawareness || data.aabehavior) {
            data.awareness = data.aaawareness;
            data.behavior = data.aabehavior;
        }
        apiRequest(
            `${endpoints.BASE_EVENT_REPORT_PATH}/update`,
            getState().auth.jwtToken,
            'POST',
            JSON.stringify({ data })
        ).then(payload => {
            if (payload.errors) {
                if (Array.isArray(payload.errors[0].detail)) {
                    dispatch(
                        setEventErrorMessage(payload.errors[0].detail[0].detail)
                    );
                } else {
                    dispatch(setEventErrorMessage(payload.errors[0].detail));
                }
                dispatch(eventActionOverlaySuccess());
            } else {
                Promise.all([
                    dispatch(clearAllErrors()),
                    dispatch(
                        setEventSuccessMessage(
                            `After Action updated at ${moment().format(
                                'YYYY-MM-DD HH:MM:SS'
                            )}.`
                        )
                    ),
                    dispatch(submitAfterAction(data)),
                    dispatch(fetchAATaskThunk(data.id))
                ]).then(() => {
                    dispatch(eventActionOverlaySuccess());
                });
            }
        });
    });
};

export const submitAfterAction = data => (dispatch, getState) => {
    const now = moment();
    if (moment(getState().events.endDate).isAfter(now)) {
        dispatch(
            setEventErrorMessage(
                'You cannot submit this after action until the event has been completed.'
            )
        );
    } else {
        let postBody = JSON.stringify({ data: { id: data.id } });
        if (data.aaApproverId) {
            postBody = JSON.stringify({
                data: { id: data.id, next: data.aaApproverId }
            });
        }
        apiRequest(
            `${endpoints.BASE_EVENT_REPORT_PATH}/submit`,
            getState().auth.jwtToken,
            'POST',
            postBody
        ).then(payload => {
            if (payload.errors) {
                if (Array.isArray(payload.errors[0].detail)) {
                    dispatch(
                        setEventErrorMessage(payload.errors[0].detail[0].detail)
                    );
                } else {
                    dispatch(setEventErrorMessage(payload.errors[0].detail));
                }
            } else {
                dispatch(latestStatus(getState().events.id));
                dispatch(clearAllErrors());
                dispatch(setEventSuccessMessage('After Action submitted.'));
                dispatch(setAAStatus('Submitted'));
                dispatch(fetchAATaskThunk(data.id));
            }
        });
    }
};

export const latestStatus = id => (dispatch, getState) => {
    apiRequest(
        `${endpoints.EVENT_DETAIL_PATH}/${id}?include[]=EventReport`,
        getState().auth.jwtToken
    ).then(payload => {
        let groupStatus = getStatus(
            payload.data[0].status,
            payload.data[0].subStatus,
            payload.data[0].EventReport,
            payload.data[0].startDate
        );
        dispatch(setGroupStatus(groupStatus.status, groupStatus.subStatus));
    });
};

export const approveAfterAction = data => (dispatch, getState) => {
    dispatch(eventActionOverlayLoading('Approve After Action'));
    let postBody = JSON.stringify({ data: { id: data.id } });
    let approvers = getState().events.aaApprovers;

    if (approvers.length === 1) {
        data.aaApproverId = approvers[0].code;
    }

    if (data.aaApproverId) {
        postBody = JSON.stringify({
            data: { id: data.id, next: data.aaApproverId }
        });
    }

    apiRequest(
        `${endpoints.BASE_EVENT_REPORT_PATH}/approve`,
        getState().auth.jwtToken,
        'POST',
        postBody
    ).then(payload => {
        if (payload.errors) {
            if (Array.isArray(payload.errors[0].detail)) {
                dispatch(
                    setEventErrorMessage(payload.errors[0].detail[0].detail)
                );
            } else {
                dispatch(setEventErrorMessage(payload.errors[0].detail));
            }
            dispatch(eventActionOverlaySuccess());
        } else {
            Promise.all([
                dispatch(clearAllErrors()),
                dispatch(
                    setEventSuccessMessage(
                        `After Action approved at ${moment().format(
                            'YYYY-MM-DD HH:MM:SS'
                        )}.`
                    )
                ),
                // dispatch(submitAfterAction(data)),
                dispatch(latestStatus(getState().events.id)),
                dispatch(fetchAATaskThunk(data.id)),
                dispatch(setAAStatus('Approved'))
            ]).then(() => {
                dispatch(eventActionOverlaySuccess());
            });
        }
    });
};

export const requestInfoAfterAction = data => (dispatch, getState) => {
    dispatch(eventActionOverlayLoading('Returned for Edit After Action'));
    apiRequest(
        `${endpoints.BASE_EVENT_REPORT_PATH}/requestinfo`,
        getState().auth.jwtToken,
        'POST',
        JSON.stringify({ data })
    ).then(payload => {
        if (payload.errors) {
            if (Array.isArray(payload.errors[0].detail)) {
                dispatch(
                    setEventErrorMessage(payload.errors[0].detail[0].detail)
                );
            } else {
                dispatch(setEventErrorMessage(payload.errors[0].detail));
            }
            dispatch(eventActionOverlaySuccess());
        } else {
            const userInfo = getState().data.userInfo;
            const commentObj = {
                reportId: data.id,
                comments: data.aaRequestComments,
                rank: userInfo.rank,
                firstName: userInfo.firstName,
                lastName: userInfo.lastName
            };

            Promise.all([
                dispatch(clearAllErrors()),
                dispatch(
                    setEventSuccessMessage(
                        `Information requested at ${moment().format(
                            'YYYY-MM-DD HH:MM:SS'
                        )}.`
                    )
                ),
                dispatch(latestStatus(getState().events.id)),
                dispatch(createAACommentThunk(commentObj)),
                dispatch(setAAStatus('RFI')),
                dispatch(fetchAATaskThunk(data.id))
            ]).then(() => {
                dispatch(eventActionOverlaySuccess());
            });
        }
    });
};

export const rejectAfterAction = data => (dispatch, getState) => {
    dispatch(eventActionOverlayLoading('Reject After Action'));
    apiRequest(
        `${endpoints.BASE_EVENT_REPORT_PATH}/reject`,
        getState().auth.jwtToken,
        'POST',
        JSON.stringify({ data })
    ).then(payload => {
        if (payload.errors) {
            if (Array.isArray(payload.errors[0].detail)) {
                dispatch(
                    setEventErrorMessage(payload.errors[0].detail[0].detail)
                );
            } else {
                dispatch(setEventErrorMessage(payload.errors[0].detail));
            }
        } else {
            dispatch(latestStatus(getState().events.id));
            dispatch(clearAllErrors());
        }
    });
    dispatch(eventActionOverlaySuccess());
};

export const purchaseRequestFiles = id => dispatch => {
    dispatch(actions.push('PurchaseRequest.media[]', id));
};

export const clearAllErrors = id => dispatch => {
    dispatch(setEventErrorMessage(null));
    const validObj = {
        formOneValid: true,
        formTwoValid: true
    };
    dispatch(setInvalidTabs(validObj));
};

export const setEventUserAction = action => {
    return {
        type: types.SET_EVENT_USER_ACTION,
        action
    };
};

export const toggleEventRejectModal = () => (dispatch, getState) => {
    const isActive = getState().events.rejectModalActive;
    dispatch(setEventRejectModalActive(!isActive));
};

export const toggleEventRequestModal = () => (dispatch, getState) => {
    const isActive = getState().events.requestModalActive;
    dispatch(setEventRequestModalActive(!isActive));
};

export const toggleEventApproveModal = () => (dispatch, getState) => {
    const isActive = getState().events.approveModalActive;
    dispatch(setEventApproveModalActive(!isActive));
};

export const toggleAAApproveModal = () => (dispatch, getState) => {
    const isActive = getState().events.aaApproveModalActive;
    dispatch(setAAApproveModalActive(!isActive));
};

export const setEventRejectModalActive = bool => {
    return {
        type: types.SET_EVENT_REJECT_MODAL_ACTIVE,
        bool
    };
};

export const setEventRequestModalActive = bool => {
    return {
        type: types.SET_EVENT_REQUEST_MODAL_ACTIVE,
        bool
    };
};

export const setEventApproveModalActive = bool => {
    return {
        type: types.SET_EVENT_APPROVE_MODAL_ACTIVE,
        bool
    };
};

export const setAAApproveModalActive = bool => {
    return {
        type: types.SET_AA_APPROVE_MODAL_ACTIVE,
        bool
    };
};

export const setEventAfterActionsMod = bool => {
    return {
        type: types.SET_EVENT_AFTER_ACTION_MOD,
        bool
    };
};

export const fetchEventApprovers = amount => (dispatch, getState) => {
    let id = getState().data.userInfo.id;
    let status = getState().events.status;
    let taskUserId;
    let aaTaskUserId;
    //if it is a trusted user, use the trusted user id
    if (getState().events.tasks.length > 0) {
        const tasks = getState().events.tasks;
        const mostRecentTask = last(sortBy(tasks, 'id'));
        taskUserId = mostRecentTask.userId;
    }
    if (getState().events.aaTasks.length > 0) {
        const tasks = getState().events.aaTasks;
        const mostRecentTask = last(sortBy(tasks, 'id'));
        aaTaskUserId = mostRecentTask.userId;
    }
    //if Incomplete (yes) Trusted user and Original User
    //if its an event
    if (
        getState().events.status === 'Incomplete' &&
        getState().events.groupStatus.status === 'Event Creation' &&
        getState().event.createdById
    ) {
        // console.log("if it's an event creation");
        id = getState().event.createdById;
    } else if (
        (getState().events.groupStatus.status === 'After Action Incomplete' ||
            getState().events.groupStatus.status === 'After Action Pending') &&
        getState().event.EventReport
    ) {
        //if it's an after action
        // console.log(`if it's an after action`);
        id = getState().event.EventReport.userId;
    } else if (
        status === 'Unapproved' &&
        getState().events.groupStatus.status === 'Event Review'
    ) {
        //Event Pending Approval/Unapproved (no section)
        // console.log('Event Pending Approval/Unapproved (no section)');
        // if event status status = needs approval after submitting
        id = taskUserId;
    } else if (getState().event.EventReport) {
        //After action Pending Approval/Unapproved (no section)
        if (
            status === 'Approved' &&
            getState().event.EventReport.status === 'Unapproved' &&
            getState().events.groupStatus.status === 'After Action Review'
        ) {
            // if after action status = needs approval after submitting
            id = aaTaskUserId;
        }
    }

    const request = `?amount=${amount}&id=${id}`;
    // console.log('Approver fetch ID ', id);
    apiRequest(
        `${endpoints.USER_INFO_PATH}${request}`,
        getState().auth.jwtToken
    ).then(payload => {
        if (payload.errors) {
            if (Array.isArray(payload.errors[0].detail)) {
                dispatch(
                    setEventErrorMessage(payload.errors[0].detail[0].detail)
                );
            } else {
                dispatch(setEventErrorMessage(payload.errors[0].detail));
            }
        } else {
            const mappedEventApprovers = payload.data.permissions.approvers.Event.map(
                item => {
                    return {
                        code: item.id,
                        name: `${item.rank} ${item.firstName} ${item.lastName}`
                    };
                }
            );
            dispatch(setApproverVal(''));
            dispatch(setEventApprovers(mappedEventApprovers));

            const mappedReportApprovers = payload.data.permissions.approvers.Report.map(
                item => {
                    return {
                        code: item.id,
                        name: `${item.rank} ${item.firstName} ${item.lastName}`
                    };
                }
            );
            dispatch(setAAAproverVal(''));
            dispatch(setAAApprovers(mappedReportApprovers));
        }
    });
};

export const setEventApprovers = approvers => {
    return {
        type: types.SET_EVENT_APPROVERS,
        approvers
    };
};

export const setAAApprovers = approvers => {
    return {
        type: types.SET_AA_APPROVERS,
        approvers
    };
};

export const setApproverVal = val => dispatch => {
    dispatch(actions.merge('event', { approverId: val }));
};

export const setAAAproverVal = val => (dispatch, getState) => {
    let approverId = val;
    if (
        typeof getState().event.EventReport !== 'undefined' &&
        getState().event.EventReport.approverId
    ) {
        approverId = getState().event.EventReport.approverId;
    }
    dispatch(actions.merge('event', { aaApproverId: approverId }));
};

export const createAANoteThunk = data => (dispatch, getState) => {
    dispatch(eventActionOverlayLoading('Saving Notes'));
    const userInfo = getState().data.userInfo;
    const postBody = JSON.stringify({
        data: {
            eventId: getState().event.id,
            comments: getState().event.notesToAdd,
            rank: userInfo.rank,
            firstName: userInfo.firstName,
            lastName: userInfo.lastName
        }
    });
    apiRequest(
        `${endpoints.BASE_COMMENT_PATH}/create`,
        getState().auth.jwtToken,
        'POST',
        postBody
    ).then(payload => {
        if (payload.errors) {
            if (Array.isArray(payload.errors[0].detail)) {
                dispatch(
                    setEventErrorMessage(payload.errors[0].detail[0].detail)
                );
            } else {
                dispatch(setEventErrorMessage(payload.errors[0].detail));
            }
            dispatch(eventActionOverlaySuccess());
        } else {
            dispatch(clearAllErrors());
            dispatch(addAANote(payload.data));
            dispatch(actions.reset('event.notesToAdd', null));
            dispatch(eventActionOverlaySuccess());
        }
    });
};

export const fetchAANoteThunk = id => (dispatch, getState) => {
    apiRequest(
        `${endpoints.BASE_COMMENT_PATH}/search?eventId=${id}`,
        getState().auth.jwtToken
    ).then(payload => {
        if (payload.errors) {
            if (Array.isArray(payload.errors[0].detail)) {
                dispatch(
                    setEventErrorMessage(payload.errors[0].detail[0].detail)
                );
            } else {
                dispatch(setEventErrorMessage(payload.errors[0].detail));
            }
        } else {
            dispatch(clearAllErrors());
            dispatch(setAANotes(payload.data));
        }
    });
};

export const addAANote = note => {
    return {
        type: types.ADD_AA_NOTE,
        note
    };
};

export const setAANotes = notes => {
    return {
        type: types.SET_AA_NOTES,
        notes
    };
};

export const setAAStatus = status => {
    return {
        type: types.SET_AA_STATUS,
        status
    };
};

export const uploadFileThunk = (id, file) => (dispatch, getState) => {
    const postBody = JSON.stringify({ data: { file } });
    apiRequest(
        `${endpoints.MEDIA_UPLOAD}`,
        getState().auth.jwtToken,
        'POST',
        postBody,
        true
    ).then(response => {
        if (response.errors) {
        } else {
            let filesArray = response.data[0];
            let payload = {
                id: filesArray.id,
                type: 'Event',
                eventId: this.props.eventId
            };
            dispatch(associateUploadedFile(payload));
        }
    });
};

export const calcEventSaveSubmit = () => (dispatch, getState) => {
    const userInfo = getState().data.userInfo;
    const eventStatus = getState().events.status;
    const tasks = getState().events.tasks;

    let userCanSave = false;
    if (userInfo.permissions.resources.Event.includes('Create')) {
        if (eventStatus === 'Incomplete') {
            if (
                getState().events.userIsCreator ||
                typeof getState().events.id !== 'number'
            ) {
                userCanSave = true;
            }
        } else if (eventStatus === 'Unapproved') {
            if (tasks.length > 0) {
                const mostRecentTask = last(sortBy(tasks, 'id'));
                if (
                    mostRecentTask.action === 'Info' &&
                    mostRecentTask.userId === userInfo.id
                ) {
                    userCanSave = true;
                }
            }
        }
    }

    dispatch(setEventSaveSubmit(userCanSave));
};

export const setEventSaveSubmit = bool => {
    return {
        type: types.SET_EVENT_SAVE_SUBMIT,
        bool
    };
};

export const calcEventApproveReject = () => (dispatch, getState) => {
    const userInfo = getState().data.userInfo;
    const eventStatus = getState().events.status;
    const tasks = getState().events.tasks;
    // const trustedUser = getState().data.userInfo.TrustingUser;
    const trustingUserId = getState().data.userInfo.TrustingUser
        ? getState().data.userInfo.TrustingUser.id
        : null;
    let userCanApprove = false;
    if (userInfo.permissions.resources.Event.includes('Review')) {
        if (eventStatus === 'Unapproved') {
            if (tasks.length > 0) {
                const mostRecentTask = last(sortBy(tasks, 'id'));
                if (mostRecentTask.action !== 'Info') {
                    if (mostRecentTask.userId === userInfo.id) {
                        userCanApprove = true;
                    }
                    if (mostRecentTask.userId === trustingUserId) {
                        userCanApprove = true;
                    }
                }
            }
        }
    }

    dispatch(setEventApproveReject(userCanApprove));
};

export const setEventApproveReject = bool => {
    return {
        type: types.SET_EVENT_APPROVE_REJECT,
        bool
    };
};

export const setPRStatus = status => {
    return {
        type: types.SET_PR_STATUS,
        status
    };
};

export const calcPRAccessible = (cost = false) => (dispatch, getState) => {
    let canAccessPR = false;

    const cost = getState().forms.event.cost;
    const contract = getState().forms.event.contract;

    if (cost && cost.value && cost.value > 0) {
        if (contract && contract.value && contract.value === '0') {
            canAccessPR = true;
        }
    }

    dispatch(setPRAccessible(canAccessPR));
};

export const calcPRSaveSubmit = () => (dispatch, getState) => {
    const userInfo = getState().data.userInfo;
    const eventStatus = getState().events.status;
    const cost = getState().forms.event.cost;
    const contract = getState().forms.event.contract;
    const tasks = getState().events.tasks;
    const prStatus = getState().events.prStatus;

    let userCanEditPR = false;
    let canAccessPR = false;
    if (getState().events.id) {
        if (cost && cost.value && cost.value > 0) {
            if (contract && contract.value && contract.value === '0') {
                canAccessPR = true;
                if (getState().events.userIsCreator) {
                    if (eventStatus === 'Incomplete') {
                        userCanEditPR = true;
                    } else if (eventStatus === 'Unapproved') {
                        if (
                            prStatus === 'Incomplete' ||
                            prStatus === 'Pending' ||
                            typeof prStatus !== 'string'
                        ) {
                            userCanEditPR = true;
                        } else if (tasks.length === 0) {
                            userCanEditPR = true;
                        } else {
                            const mostRecentTask = last(sortBy(tasks, 'id'));
                            if (
                                mostRecentTask.action === 'Info' &&
                                mostRecentTask.userId === userInfo.id
                            ) {
                                userCanEditPR = true;
                            }
                        }
                    }
                }
            }
        }
    }

    dispatch(setPRAccessible(canAccessPR));
    dispatch(setPRSaveSubmit(userCanEditPR));
};

export const setPRSaveSubmit = bool => {
    return {
        type: types.SET_PR_SAVE_SUBMIT,
        bool
    };
};

export const setPRAccessible = bool => {
    return {
        type: types.SET_PR_ACCESSIBLE,
        bool
    };
};

export const updatePromoItemsTotal = total => dispatch => {
    dispatch(actions.change('event.promoTotal', total));
};

export const loadPromoItem = object => dispatch => {
    dispatch(actions.change('event.newPromoLineItem', object));
};

export const clearPromoLineItem = object => dispatch => {
    dispatch(actions.load('event.newPromoLineItem', object));
};

export const addPromoLineItem = object => dispatch => {
    dispatch(actions.push('event.PromotionalItem[]', object));
};

export const handlePromoItemsThunk = (eventId, promoItems) => dispatch => {
    const newPromoItems = promoItems.filter(item => !item.id);

    const existingPromoItems = promoItems.filter(item => item.id);

    if (existingPromoItems.length > 0) {
        for (let i = 0; i < existingPromoItems.length; i++) {
            let item = existingPromoItems[i];

            if (item.EventPromotionalItem) {
                //dispatch to update endpoint
                let id = item.EventPromotionalItem.id;
                let qty = item.quantity;
                dispatch(updateAssociatedPromoItem(eventId, id, qty));
            } else {
                let id = item.id;
                let qty = item.quantity;
                dispatch(associatePromoItem(eventId, id, qty));
            }
        }
    }
    if (newPromoItems.length > 0) {
        dispatch(createPromoItem(eventId, newPromoItems));
    }
};

export const createPromoItem = (eventId, promoItems) => (
    dispatch,
    getState
) => {
    for (let i = 0; i < promoItems.length; i++) {
        const promo = promoItems[i];
        let id = promo.name;
        let qty = parseInt(promo.quantity, 10);
        apiRequest(
            `${endpoints.PROMO_ITEMS}/create`,
            getState().auth.jwtToken,
            'POST',
            JSON.stringify({ data: { name: id } })
        ).then(payload => {
            let newPromoItemId = payload.data.id;
            dispatch(associatePromoItem(eventId, newPromoItemId, qty));
        });
    }
};

export const associatePromoItem = (eventId, promoItemId, qty) => (
    dispatch,
    getState
) => {
    apiRequest(
        `${endpoints.EVENT_PROMO_ITEMS}/create`,
        getState().auth.jwtToken,
        'POST',
        JSON.stringify({
            data: {
                eventId: eventId,
                promotionalItemId: promoItemId,
                quantity: qty
            }
        })
    ).then(payload => {
        console.log(payload);
    });
};

export const updateAssociatedPromoItem = (eventId, promoItemId, qty) => (
    dispatch,
    getState
) => {
    apiRequest(
        `${endpoints.EVENT_PROMO_ITEMS}/update`,
        getState().auth.jwtToken,
        'POST',
        JSON.stringify({
            data: {
                eventId: eventId,
                id: promoItemId,
                quantity: qty
            }
        })
    ).then(payload => {
        console.log(payload);
    });
};

export const deletePromoItemThunk = (id, promoItemId) => (
    dispatch,
    getState
) => {
    dispatch(eventActionOverlayLoading('Deleting Promo Item'));
    if (promoItemId.hasOwnProperty('EventPromotionalItem')) {
        apiRequest(
            `${endpoints.EVENT_PROMO_ITEMS}/delete`,
            getState().auth.jwtToken,
            'POST',
            JSON.stringify({
                data: {
                    id: promoItemId.EventPromotionalItem.id,
                    eventId: promoItemId.EventPromotionalItem.eventId,
                    promotionalItemId:
                        promoItemId.EventPromotionalItem.promotionalItemId
                }
            })
        ).then(payload => {
            //Dispatch to remove the item from promotionalItem array in event form reducer
            dispatch(actions.remove('event.PromotionalItem[]', id));
            dispatch(eventActionOverlaySuccess());
        });
    } else {
        dispatch(actions.remove('event.PromotionalItem[]', id));
        dispatch(eventActionOverlaySuccess());
    }
};

export const handleEventFiles = file => dispatch => {
    dispatch(actions.push('event.eventFile', file));
};

export const setEventFiles = files => {
    return {
        type: types.SET_EVENT_FILES,
        files
    };
};

export const concatEventUploads = files => (dispatch, getState) => {
    const newArr = getState().events.eventFiles.concat(files);
    dispatch(setEventFiles(newArr));
};

export const createAndAssignVendor = data => (dispatch, getState) => {
    apiRequest(
        `${endpoints.VENDOR_PATH}/create`,
        getState().auth.jwtToken,
        'POST',
        JSON.stringify({ data })
    ).then(payload => {
        if (payload.data) {
            const vendorObj = {
                vendor: payload.data.id,
                event: getState().events.id
            };
            dispatch(assignVendorItem(vendorObj));
            dispatch(vendorInformation(payload.data));
        } else {
            console.log(payload);
        }
    });
};

export const updateAndAssignVendor = data => (dispatch, getState) => {
    apiRequest(
        `${endpoints.VENDOR_PATH}/update`,
        getState().auth.jwtToken,
        'POST',
        JSON.stringify({ data })
    ).then(payload => {
        if (payload.data) {
            const vendorObj = {
                vendor: data.id,
                event: getState().events.id
            };
            dispatch(assignVendorItem(vendorObj));
            dispatch(vendorInformation(data));
        } else {
            console.log(payload);
        }
    });
};

export const assignVendorItem = data => (dispatch, getState) => {
    apiRequest(
        `${endpoints.EVENT_VENDOR_PATH}/create`,
        getState().auth.jwtToken,
        'POST',
        JSON.stringify({ data })
    ).then(payload => {
        console.log(payload);
    });
};

export const createAndStoreVendor = data => (dispatch, getState) => {
    apiRequest(
        `${endpoints.VENDOR_PATH}/create`,
        getState().auth.jwtToken,
        'POST',
        JSON.stringify({ data })
    ).then(payload => {
        if (payload.data) {
            dispatch(storeVendorItem(payload.data));
            dispatch(vendorInformation(payload.data));
        } else {
            console.log(payload);
        }
    });
};

export const updateAndStoreVendor = data => (dispatch, getState) => {
    apiRequest(
        `${endpoints.VENDOR_PATH}/update`,
        getState().auth.jwtToken,
        'POST',
        JSON.stringify({ data })
    ).then(payload => {
        if (payload.data) {
            dispatch(storeVendorItem(data));
            dispatch(vendorInformation(data));
        } else {
            console.log(payload);
        }
    });
};

export const storeVendorItem = vendor => {
    return {
        type: types.ADD_VENDOR_ITEM,
        vendor
    };
};

export const clearVendorItems = () => {
    return {
        type: types.CLEAR_VENDOR_ITEMS
    };
};

export const setVendorsDropdown = status => {
    return {
        type: types.SET_VENDORS_DROPDOWN,
        status
    };
};

export const loadInitialPromoItems = items => dispatch => {
    dispatch(actions.load('event.PromotionalItem[]', items));
};

export const addPromoItems = promoItems => ({
    type: types.ADD_PROMO_ITEMS,
    promoItems
});

export const createPurchaseRequestId = data => (dispatch, getState) => {
    apiRequest(
        `${endpoints.PURCHASE_REQUEST}/create`,
        getState().auth.jwtToken,
        'POST',
        data
    ).then(payload => {
        if (!payload.errors) {
            dispatch(actions.merge('PurchaseRequest', { id: payload.data.id }));
            dispatch(
                actions.merge('PurchaseRequest.newItem', {
                    purchaseRequestId: payload.data.id
                })
            );
        }
    });
};

export const createPurchaseRequestThunk = data => (dispatch, getState) => {
    dispatch(eventActionOverlayLoading('Create Purchase Request'));
    apiRequest(
        `${endpoints.PURCHASE_REQUEST}/create`,
        getState().auth.jwtToken,
        'POST',
        JSON.stringify({ data })
    ).then(payload => {
        if (payload.errors) {
            if (Array.isArray(payload.errors[0].detail)) {
                dispatch(
                    setEventErrorMessage(payload.errors[0].detail[0].detail)
                );
            } else {
                dispatch(setEventErrorMessage(payload.errors[0].detail));
            }
        } else {
            dispatch(clearAllErrors());
            dispatch(
                setEventSuccessMessage(
                    `Purchase request saved at ${moment().format(
                        'YYYY-MM-DD HH:MM:SS'
                    )}.`
                )
            );

            dispatch(setPRComplete(true));

            if (data.media) {
                dispatch(
                    handlePurchaseRequestMedia(payload.data.id, data.media)
                );
            }

            if (data.PurchaseRequestItem) {
                for (let i = 0; i < data.PurchaseRequestItem.length; i += 1) {
                    const item = data.PurchaseRequestItem[i];
                    dispatch(updatePurchaseRequestItemId(i, item.id));
                    if (item.id) {
                        dispatch(updatePurchaseRequestItem(item));
                    } else {
                        dispatch(createPurchaseRequestItem(item, i));
                    }
                }
            }

            dispatch(actions.merge('PurchaseRequest', { id: payload.data.id }));
        }
        dispatch(eventActionOverlaySuccess());
    });
};

export const updatePurchaseRequestThunk = data => (dispatch, getState) => {
    dispatch(eventActionOverlayLoading('Update Purchase Request'));
    apiRequest(
        `${endpoints.PURCHASE_REQUEST}/update`,
        getState().auth.jwtToken,
        'POST',
        JSON.stringify({ data })
    ).then(payload => {
        if (payload.errors) {
            if (Array.isArray(payload.errors[0].detail)) {
                dispatch(
                    setEventErrorMessage(payload.errors[0].detail[0].detail)
                );
            } else {
                dispatch(setEventErrorMessage(payload.errors[0].detail));
            }
        } else {
            dispatch(clearAllErrors());
            dispatch(
                setEventSuccessMessage(
                    `Purchase request updated at ${moment().format(
                        'YYYY-MM-DD HH:MM:SS'
                    )}.`
                )
            );

            dispatch(setPRComplete(true));

            if (data.media) {
                dispatch(handlePurchaseRequestMedia(data.id, data.media));
                //Reloads the data from the database to show the uploaded files.
                dispatch(fetchPurchaseRequestThunk(data.eventId));
            }

            if (data.PurchaseRequestItem) {
                for (let i = 0; i < data.PurchaseRequestItem.length; i += 1) {
                    const item = data.PurchaseRequestItem[i];
                    if (item.id) {
                        dispatch(updatePurchaseRequestItem(item));
                    } else {
                        dispatch(createPurchaseRequestItem(item, i));
                    }
                }
            }
        }
        dispatch(eventActionOverlaySuccess());
    });
};

export const updatePurchaseRequestItem = data => (dispatch, getState) => {
    apiRequest(
        `${endpoints.PURCHASE_REQUEST_ITEM}/update`,
        getState().auth.jwtToken,
        'POST',
        JSON.stringify({ data })
    ).then(payload => {
        if (payload.errors) {
            console.log(payload);
        } else {
            dispatch(setPRComplete(true));
        }
    });
};

export const createPurchaseRequestItem = (data, index) => (
    dispatch,
    getState
) => {
    apiRequest(
        `${endpoints.PURCHASE_REQUEST_ITEM}/create`,
        getState().auth.jwtToken,
        'POST',
        JSON.stringify({ data })
    ).then(payload => {
        if (payload.errors) {
            console.log(payload);
        } else {
            dispatch(
                actions.merge(`PurchaseRequest.PurchaseRequestItem[${index}]`, {
                    id: payload.data.id
                })
            );

            dispatch(setPRComplete(true));
        }
    });
};

export const handleStorePurchaseRequest = data => dispatch => {
    dispatch(setPRComplete(true));
    dispatch(storePurchaseRequest(data));
    dispatch(
        setEventSuccessMessage(
            'Purchase request saved temporarily. Please save your event to permanently save your purchase request.'
        )
    );
};

export const setPRComplete = bool => {
    return {
        type: types.SET_PR_COMPLETE,
        bool
    };
};

export const storePurchaseRequest = data => {
    return {
        type: types.STORE_PURCHASE_REQUEST,
        data
    };
};

export const setContract = contract => {
    return {
        type: types.SET_CONTRACT,
        contract
    };
};

export const fetchParentSearch = name => (dispatch, getState) => {
    apiRequest(
        `${
            endpoints.EVENT_SEARCH_PATH
        }?name=${name}&filters[Event][status][in][]=Approved&include[]=Parent&include[]=Children&filters[Event][updatedAt][gte]=${moment()
            .subtract(6, 'months')
            .format('YYYY-MM-DD')}`,
        getState().auth.jwtToken
    ).then(payload => {
        if (payload.data) {
            let resultArr = payload.data;

            //Remove Grand-Children Events (If Event has Children && parentId, Remove These Children Events from payload)
            //FIND Grand-Child id's
            let grandChildId = [];
            for (let i = 0; i < resultArr.length; i += 1) {
                if (
                    !!resultArr[i].Children &&
                    resultArr[i].Children.length > 0 &&
                    !!resultArr[i].parentId
                ) {
                    for (
                        let i2 = 0;
                        i2 < resultArr[i].Children.length;
                        i2 += 1
                    ) {
                        grandChildId.push(resultArr[i].Children[i2].id);
                    }
                }
            }
            //REMOVE grand child events
            for (let i = resultArr.length - 1; i > 0; i--) {
                if (grandChildId.includes(resultArr[i].id)) {
                    resultArr.splice(i, 1);
                }
            }

            //Check parentId is in set of results - if not Fetch and add
            let fetchParentEvents = [];
            for (let i = 0; i < resultArr.length; i += 1) {
                //Check if child
                if (!!resultArr[i].parentId) {
                    let findParent = resultArr[i].parentId;
                    let parentFound = false;
                    for (let i2 = 0; i2 < resultArr.length; i2 += 1) {
                        if (resultArr[i2].id === findParent) {
                            parentFound = true;
                            //break;
                        }
                    }
                    if (!parentFound) {
                        fetchParentEvents.push(
                            '&filters[Event][id][in][]=' + findParent
                        );
                    }
                }
            }

            if (fetchParentEvents.length > 0) {
                apiRequest(
                    `${
                        endpoints.EVENT_SEARCH_PATH
                    }?filters[Event][status][in][]=Approved&include[]=Parent&include[]=Children${fetchParentEvents}`,
                    getState().auth.jwtToken
                ).then(payload => {
                    if (payload.data) {
                        resultArr = resultArr.concat(payload.data);

                        //Arrange Events with parentID After Event with matching id
                        //count number of parentId
                        let loopCount = resultArr.length;
                        let eventIdWithParentId = [];
                        for (let i = 0; i < loopCount; i += 1) {
                            if (!!resultArr[i].parentId) {
                                eventIdWithParentId.push(resultArr[i].id);
                            }
                        }

                        for (
                            let i = 0;
                            i < eventIdWithParentId.length;
                            i += 1
                        ) {
                            for (let i2 = 0; i2 < loopCount; i2 += 1) {
                                if (
                                    eventIdWithParentId[i] === resultArr[i2].id
                                ) {
                                    //i2 is current index of child event with parentId
                                    let parentIdToFind = resultArr[i2].parentId;
                                    for (let i3 = 0; i3 < loopCount; i3 += 1) {
                                        if (
                                            parentIdToFind === resultArr[i3].id
                                        ) {
                                            //i3 is current index of parent event
                                            resultArr.splice(
                                                i3 + 1,
                                                0,
                                                resultArr[i2]
                                            );
                                            if (i2 < i3) {
                                                resultArr.splice(i2, 1);
                                            } else {
                                                resultArr.splice(i2 + 1, 1);
                                            }
                                        }
                                    }
                                }
                            }
                        }

                        //Return only 10 results
                        if (payload.data.length > 10) {
                            resultArr = payload.data.slice(0, 10);
                        }
                        dispatch(setParentSearch(resultArr));
                    } else {
                        console.log(payload);
                    }
                });
            } else {
                //Arrange Events with parentID After Event with matching id
                let loopCount = resultArr.length;
                let eventIdWithParentId = [];
                for (let i = 0; i < loopCount; i += 1) {
                    if (!!resultArr[i].parentId) {
                        eventIdWithParentId.push(resultArr[i].id);
                    }
                }

                for (let i = 0; i < eventIdWithParentId.length; i += 1) {
                    for (let i2 = 0; i2 < loopCount; i2 += 1) {
                        if (eventIdWithParentId[i] === resultArr[i2].id) {
                            //i2 is current index of child event with parentId
                            let parentIdToFind = resultArr[i2].parentId;
                            for (let i3 = 0; i3 < loopCount; i3 += 1) {
                                if (parentIdToFind === resultArr[i3].id) {
                                    //i3 is current index of parent event
                                    resultArr.splice(i3 + 1, 0, resultArr[i2]);
                                    if (i2 < i3) {
                                        resultArr.splice(i2, 1);
                                    } else {
                                        resultArr.splice(i2 + 1, 1);
                                    }
                                }
                            }
                        }
                    }
                }

                //Return only 10 results
                if (payload.data.length > 10) {
                    resultArr = payload.data.slice(0, 10);
                }

                dispatch(setParentSearch(resultArr));
            }
        } else {
            console.log(payload);
        }
    });
};

export const setParentSearch = items => {
    return {
        type: types.SET_PARENT_SEARCH,
        items
    };
};

export const resetTime = dateType => dispatch => {
    dispatch(actions.change('event.endTime', ''));
    dispatch(actions.change('event.startTime', ''));
    if (dateType === 'sDate') {
        dispatch(actions.change('event.sDate', ''));
    } else if (dateType === 'eDate') {
        dispatch(actions.change('event.eDate', ''));
    }
};

export const checkMaster = e => dispatch => {
    if (e.target.value === '0') {
        dispatch(actions.change('event.parentName', 'null'));
        dispatch(actions.change('event.parentId', 'null'));
    }
};

export const handleSetParentEvent = (item, name) => dispatch => {
    let itemName = item.name;
    if (name === 'qualifiedName') {
        itemName = item.qualifiedName;
    }
    dispatch(
        actions.merge('event', { parentName: itemName, parentId: item.id })
    );
    dispatch(setParentSearch([]));
};

export const clearPurchaseRequestData = item => dispatch => {
    dispatch(actions.load('PurchaseRequest', item));
};

export const setApproverState = bool => {
    return {
        type: types.SET_APPROVER_STATE,
        bool
    };
};

export const setPRModal = bool => {
    return {
        type: types.SET_PR_MODAL,
        bool
    };
};

export const setMCRCUploadedFile = bool => {
    return {
        type: types.SET_MCRC_UPLOADED_FILE,
        bool
    };
};

export const setDistrictUploadedFile = bool => {
    return {
        type: types.SET_DISTRICT_UPLOADED_FILE,
        bool
    };
};

export const setRegionalUploadedFile = bool => {
    return {
        type: types.SET_REGIONAL_UPLOADED_FILE,
        bool
    };
};

export const setOnsiteActivations = num => {
    return {
        type: types.SET_ONSITE_ACTIVATIONS,
        num
    };
};

export const setOnsiteDates = dates => {
    return {
        type: types.SET_ONSITE_DATES,
        dates
    };
};

export const createOnsiteDateThunk = data => (dispatch, getState) => {
    apiRequest(
        `${endpoints.ONSITE_DATE_PATH}/create`,
        getState().auth.jwtToken,
        'POST',
        JSON.stringify({ data })
    ).then(payload => {
        if (payload.errors) {
            console.log(payload);
        }
    });
};

export const updateOnsiteDateThunk = data => (dispatch, getState) => {
    apiRequest(
        `${endpoints.ONSITE_DATE_PATH}/update`,
        getState().auth.jwtToken,
        'POST',
        JSON.stringify({ data })
    ).then(payload => {
        if (payload.errors) {
            console.log(payload);
        }
    });
};

export const setAARecommended = bool => {
    return {
        type: types.SET_AA_RECOMMENDED,
        bool
    };
};

export const setEventRecommended = bool => {
    return {
        type: types.SET_EVENT_RECOMMENDED,
        bool
    };
};

export const fetchEventPDFThunk = id => (dispatch, getState) => {
    apiRequest(
        `${endpoints.EVENT_ADREQUEST_PATH}?id=${id}`,
        getState().auth.jwtToken
    ).then(payload => {
        if (payload.errors) {
            console.log(payload);
        } else {
            window.open(payload);
            console.log(payload);
        }
    });
};

export const setAARequestModal = bool => {
    return {
        type: types.SET_AA_REQUEST_MODAL,
        bool
    };
};

export const toggleAARequestModal = () => (dispatch, getState) => {
    const opp = !getState().events.aaRequestModalActive;
    dispatch(setAARequestModal(opp));
};

export const fetchAACommentsThunk = id => (dispatch, getState) => {
    apiRequest(
        `${endpoints.EVENT_REPORT_COMMENT_PATH}/search?id=${id}`,
        getState().auth.jwtToken
    ).then(payload => {
        if (payload.errors) {
            console.log(payload);
        } else if (payload.data.length > 0) {
            const mostRecentComment = last(sortBy(payload.data, 'id'));
            dispatch(setAARequestMessage(mostRecentComment.comments));
        }
    });
};

export const setAARequestMessage = message => {
    return {
        type: types.SET_AA_REQUEST_MESSAGE,
        message
    };
};

export const setSelectedCategories = categories => {
    return {
        type: types.SET_SELECTED_CATEGORIES,
        categories
    };
};

export const setDefaultVendorPR = code => dispatch => {
    dispatch(actions.merge('PurchaseRequest.newItem', { vendorId: code }));
};

export const setShowEventRecommend = bool => {
    return {
        type: types.SET_SHOW_EVENT_RECOMMEND,
        bool
    };
};

export const setEventEndDate = date => {
    return {
        type: types.SET_EVENT_END_DATE,
        date
    };
};

export const fetchParentIDEventName = id => (dispatch, getState) => {
    apiRequest(
        `${endpoints.EVENT_DETAIL_PATH}/${id}`,
        getState().auth.jwtToken
    ).then(payload => {
        if (payload.errors) {
            console.log(payload);
        } else {
            dispatch(
                // actions.merge('event', { parentName: payload.data[0].name })
                actions.merge('event', {
                    parentName: payload.data[0].qualifiedName
                })
            );
        }
    });
};

export const setEventDates = (startDate, endDate) => (dispatch, getState) => {
    dispatch(actions.change('event.sDate', startDate));
    dispatch(actions.change('event.eDate', endDate));
};

export const eventActionOverlayLoading = eventActionText => {
    return {
        type: types.EVENT_ACTION_LOADING,
        eventActionText
    };
};

export const eventActionOverlaySuccess = () => {
    return {
        type: types.EVENT_ACTION_SUCCESS
    };
};

export const getLeadCountThunk = () => (dispatch, getState) => {
    if (getState().events.modalLeadCount) {
        dispatch(toggleLeadCountModal());
        return false;
    }

    //initial loading
    dispatch(toggleLeadCountModal());
    dispatch(leadCount('Loading ...'));

    const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + getState().auth.jwtToken,
        Accept: 1
    });
    const settings = {
        cache: 'reload',
        method: 'GET',
        headers
    };

    fetch(`${endpoints.LEAD_COUNT}${getState().event.sourceCode}`, settings)
        .then(response => {
            return response.json();
        })
        .then(payload => {
            dispatch(leadCount(payload.data));
        })
        .catch(e => {
            dispatch(leadCount(`Error: ${e} ...`));
        });
};

export const setOSSRSSType = event => (dispatch, getState) => {
    const type = event.target[event.target.selectedIndex].getAttribute(
        'data-type'
    );
    if (type === 'OSS') {
        dispatch(actions.change('event.fundingOssCode', event.target.value));
        dispatch(actions.change('event.fundingRecruitingSubStationCode', null));
        dispatch(actions.change('event.ossRssType', type));
    } else {
        dispatch(actions.change('event.fundingOssCode', null));
        dispatch(
            actions.change(
                'event.fundingRecruitingSubStationCode',
                event.target.value
            )
        );
        dispatch(actions.change('event.ossRssType', type));
    }
};

export const toggleLeadCountModal = () => ({
    type: types.TOGGLE_MODAL_LEAD_COUNT
});

export const leadCount = leadCount => ({
    type: types.LEAD_COUNT,
    leadCount
});

export const formSaved = saveValue => ({
    type: types.FORM_SAVED,
    saveValue
});

export const recallEventThunk = () => (dispatch, getState) => {
    dispatch(eventActionOverlayLoading('Recall Event'));
    apiRequest(
        `${endpoints.EMS}event/recall/${getState().event.id}`,
        getState().auth.jwtToken
    ).then(payload => {
        if (payload.errors) {
            console.log(payload.errors);
            dispatch(eventActionOverlaySuccess());
        } else {
            dispatch(fetchEventThunk(getState().events.id));
            dispatch(eventActionOverlaySuccess());
        }
    });
};



// WEBPACK FOOTER //
// ./src/actions/event.js